
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lVF98", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $1qfLF = parcelRequire("1qfLF");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gZTYb = parcelRequire("gZTYb");

/**
 * __AnimateIn__
 *
 * Useful for Animating in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $6260267e05cdfdb2$var$AnimateIn = ({ children: children, duration: duration = 'large', enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation, onFinish: onFinish, isPaused: isPaused, animationTimingFunction: animationTimingFunction })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gZTYb.default), {
        duration: duration,
        enteringAnimation: enteringAnimation,
        exitingAnimation: exitingAnimation,
        animationTimingFunction: animationTimingFunction,
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $6260267e05cdfdb2$export$2e2bcd8739ae039 = $6260267e05cdfdb2$var$AnimateIn;



var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $8unJx = parcelRequire("8unJx");


var $hR4U4 = parcelRequire("hR4U4");


var $jln20 = parcelRequire("jln20");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hU34N = parcelRequire("hU34N");


var $iIQbF = parcelRequire("iIQbF");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $D7PHQ = parcelRequire("D7PHQ");


var $kM55L = parcelRequire("kM55L");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $aWwYt = parcelRequire("aWwYt");


var $eNjW4 = parcelRequire("eNjW4");


var $jmjWc = parcelRequire("jmjWc");


var $e4o8D = parcelRequire("e4o8D");


var $3qFIQ = parcelRequire("3qFIQ");


var $2VQ4B = parcelRequire("2VQ4B");


var $3oZ9l = parcelRequire("3oZ9l");


var $8uM2K = parcelRequire("8uM2K");


var $bj5fB = parcelRequire("bj5fB");


var $dppWL = parcelRequire("dppWL");


var $3tUdX = parcelRequire("3tUdX");





var $4acD6 = parcelRequire("4acD6");


var $dWpd3 = parcelRequire("dWpd3");


var $3Am3T = parcelRequire("3Am3T");










var $kevJM = parcelRequire("kevJM");


var $1yB28 = parcelRequire("1yB28");


var $cUQMr = parcelRequire("cUQMr");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $afBrg = parcelRequire("afBrg");


var $6Htct = parcelRequire("6Htct");








var $9s8in = parcelRequire("9s8in");


var $auvZ1 = parcelRequire("auvZ1");


var $9VC5k = parcelRequire("9VC5k");


var $2bR8c = parcelRequire("2bR8c");





var $c8mrj = parcelRequire("c8mrj");











var $4aiCO = parcelRequire("4aiCO");


var $UNr39 = parcelRequire("UNr39");


var $auLW1 = parcelRequire("auLW1");











var $eN3MW = parcelRequire("eN3MW");


var $amW67 = parcelRequire("amW67");


var $bQm3c = parcelRequire("bQm3c");

const $a6bade25d3c467cc$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    pageCatchupMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup-subheader",
        defaultMessage: "See what's changed since your last visit"
    },
    summarizeSectionLabel: {
        id: "page-rovo-config-common.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    exploreRelatedWorkAndUpdates: {
        id: "page-rovo-config-common.menu.item.label.explore-related-items.non-final",
        defaultMessage: "Explore related work and resources"
    },
    audioBriefingMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing",
        defaultMessage: "Listen to page"
    }
});
const $a6bade25d3c467cc$export$e0c34800d984dab2 = ()=>{
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty } = (0, $amW67.useRovoConfigProviderProps)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $42omo.useContext)((0, $3Am3T.CommentCountsContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $42omo.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    // Page Catchup action
    const pageCatchupAction = (0, $42omo.useCallback)(()=>({
            id: 'summarize-changes-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                    label: "",
                    testId: "summarize-changes-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'content-catchup'
            }
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Summarize page action
    const quickSummaryAction = (0, $42omo.useCallback)(()=>({
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate ?? '',
                        source: "view-page",
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'page-summaries'
            }
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey,
        lastModifiedDate
    ]);
    // Summarize comments action
    const commentSummaryAction = (0, $42omo.useCallback)(()=>({
            id: 'summarize-comments-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.inlineCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    label: ""
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
                        contentId: contentId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auvZ1.FooterCommentsSummaryCombined), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Footer,
                        spaceKey: spaceKey,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false
                    }))
            },
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Create Jira bulk issues action
    const handleBulkIssueCreate = (0, $c8mrj.useBulkIssueCreate)({
        contentId: contentId,
        content: content
    });
    const onBulkIssueCreate = (0, $42omo.useCallback)(()=>{
        if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
        else handleBulkIssueCreate();
    }, [
        isSidePanelOpen,
        showWarningDialog,
        handleBulkIssueCreate
    ]);
    const bulkIssueCreateAction = (0, $42omo.useCallback)(()=>({
            id: 'bulk-issue-create-ai-action',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $a6bade25d3c467cc$export$defe85febe8b728c.bulkWorkItemsCreateMenuItemLabel : $a6bade25d3c467cc$export$defe85febe8b728c.bulkIssueCreateMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
                    label: ""
                }),
            onClick: onBulkIssueCreate,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base
        }), [
        formatMessage,
        onBulkIssueCreate
    ]);
    // Audio briefing action
    const { openAudioPlayer: openAudioPlayer } = (0, $9s8in.useAudioPlayerStore)();
    const { mode: rovoUiMode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const { activeContent: activeContent } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const onAudioBriefingAction = (0, $42omo.useCallback)(()=>{
        if (!!activeContent) {
            openAudioPlayer(activeContent, {
                playImmediately: true
            });
            // Close the Rovo popup or sidebar after clicking
            const isSidebarOrMiniModalOpen = rovoUiMode === (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR || rovoUiMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
            if (isSidebarOrMiniModalOpen) // Close sidebar
            toggleConversationAssistantUIMode({
                targetMode: undefined,
                sidebarApi: sidebarApi
            });
        }
    }, [
        activeContent,
        openAudioPlayer,
        rovoUiMode,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const audioBriefingAction = (0, $42omo.useCallback)(()=>({
            id: 'audio-briefing-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($afBrg))), {
                    label: ""
                }),
            onClick: onAudioBriefingAction,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            nudgeContext: {
                id: 'proactive-audio-briefing' // PROACTIVE_AI_AUDIO_BRIEFING in convo-ai
            }
        }), [
        formatMessage,
        onAudioBriefingAction
    ]);
    const audioSupportedByBrowser = (0, $42omo.useMemo)(()=>typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'), []);
    const audioBriefingV3Enabled = audioSupportedByBrowser && isAdminHubAIEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
    const audioBriefingNudgeEnabled = audioBriefingV3Enabled && ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge') || (0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay'));
    const shouldShowAudioBriefingAction = (0, $42omo.useMemo)(()=>{
        return !!activeContent && audioBriefingNudgeEnabled;
    }, [
        activeContent,
        audioBriefingNudgeEnabled
    ]);
    // Final actions list
    const getViewPageRovoActions = (0, $42omo.useCallback)(()=>{
        const actions = [];
        const isPageOrBlogpost = contentType === 'page' || contentType === 'blogpost';
        // Remove this const and use isEditorEmpty directly on experiment cleanup
        const isGatedEditorEmpty = isEditorEmpty && (0, $6mKj3.expValEquals)('platform_editor_remove_summarise_from_empty_doc', 'isEnabled', true);
        // needed for space overview since it doesn't have content type
        // also skip for unpublished drafts and empty live docs)
        if (!isPageOrBlogpost || isUnpublishedDraft || isGatedEditorEmpty) return actions;
        actions.push({
            actionId: 'page-catchup',
            action: pageCatchupAction()
        }, {
            actionId: 'quick-summary',
            action: quickSummaryAction()
        });
        if (shouldShowAudioBriefingAction) actions.push({
            actionId: 'audio-briefing',
            action: audioBriefingAction()
        });
        // Only show comment summary in Rovo button when proactive_comment_summary experiment is disabled
        if ((unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0) && !(0, $6mKj3.expValEquals)('proactive_comment_summary', 'isEnabled', true)) actions.push({
            actionId: 'comment-summary',
            action: commentSummaryAction()
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) actions.push({
            actionId: 'bulk-issue-create',
            action: bulkIssueCreateAction()
        });
        return actions;
    }, [
        contentType,
        bulkIssueCreateAction,
        commentSummaryAction,
        footerCommentsCount,
        isUnpublishedDraft,
        isEditorEmpty,
        pageCatchupAction,
        pageMode,
        quickSummaryAction,
        unresolvedInlineCommentsCount,
        audioBriefingAction,
        shouldShowAudioBriefingAction
    ]);
    const actions = (0, $42omo.useMemo)(()=>getViewPageRovoActions(), [
        getViewPageRovoActions
    ]);
    return actions;
};


















var $h2uld = parcelRequire("h2uld");

const $e4cd8876e4f83d2e$export$b68936138edb7d6e = (contentType, contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTimeMinutes, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    /**
	 * Filters to prevent high request volume checking for nudge recommendations
	 * 1. Rovo Button must be enabled
	 * 2. Content type must be 'page' (TODO: extend to 'blogpost' when backend 500s are fixed)
	 * 3. Page must not be in edit mode
	 * 4. Read time query must be completed
	 * 5. Read time must be available and more than 30 seconds
	 */ return isRovoButtonEnabled && contentType === 'page' && pageMode !== (0, $cD1qu.PageMode).EDIT && !readTimeLoading && Number(readTimeMinutes) > 0.5;
};


const $2b7ed8ae830eb95a$var$ViewPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const { contentType: contentType, contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const enableNudgeCheck = (0, $e4cd8876e4f83d2e$export$b68936138edb7d6e)(contentType, contentId);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const config = (0, $42omo.useMemo)(()=>{
        return {
            getActions: async ()=>{
                const actions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve(actions);
            }
        };
    }, [
        viewPageRovoActions
    ]);
    (0, $42omo.useEffect)(()=>{
        setConfiguration(config);
        if (!enableNudgeCheck) {
            setNudges([]);
            return;
        }
        const nudges = [
            viewPageRovoActions.find((a)=>a.actionId === 'page-catchup')?.action,
            // Only show audio briefing nudge if the user is not eligible for audio briefing changeboarding
            !eligibleForChangeboarding && viewPageRovoActions.find((a)=>a.actionId === 'audio-briefing')?.action
        ].filter(Boolean);
        if (nudges.length > 0) setNudges(nudges);
    }, [
        config,
        setConfiguration,
        enableNudgeCheck,
        viewPageRovoActions,
        setNudges,
        eligibleForChangeboarding
    ]);
    return null;
};
const $2b7ed8ae830eb95a$export$299010de885adda = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2b7ed8ae830eb95a$var$ViewPageConfigProviderInner, props));
};


/* eslint-disable confluence-feature-gating/prefer-exp-val-equals */ 











var $la9AC = parcelRequire("la9AC");





























const $23e0c73c9feee0cc$export$5569745b4d0a5343 = (contentType, _contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isLiveDoc = pageMode === (0, $cD1qu.PageMode).LIVE;
    /**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */ return isLiveDoc && isRovoButtonEnabled && contentType === 'page' && isAdminHubAIEnabled && (0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
};



var $02cx8 = parcelRequire("02cx8");

/* getEmptyPageCreationActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $1s5hv = parcelRequire("1s5hv");


var $boRaI = parcelRequire("boRaI");




const $efb362169c233167$export$4b8c4c333cdd165d = [
    'create-product-requirements-document',
    'create-customer-onboarding-strategy',
    'create-background-research-plan'
];
/* istanbul ignore next */ const $efb362169c233167$var$styles = {
    iconContainer: "_1yt412x7"
};
const $efb362169c233167$export$4e5c71902381581b = (promptCards)=>{
    const promptCardsById = new Map(promptCards.map((card)=>[
            card.id,
            card
        ]));
    return $efb362169c233167$export$4b8c4c333cdd165d.reduce((actions, targetId)=>{
        const card = promptCardsById.get(targetId);
        if (card) actions.push({
            handleType: (0, $6Htct.HandleActionType).Chat,
            id: card.id,
            title: card.title,
            dynamicPrompt: card.prompt,
            icon: ()=>{
                const Icon = (0, $boRaI.getUseCaseIcon)(card.useCase);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $efb362169c233167$var$styles.iconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, null));
            }
        });
        return actions;
    }, []);
};


var $9c464318090b4e27$exports = {};
$9c464318090b4e27$exports = new URL("empty-page-greeting-icon.9a2c7bfb.svg", import.meta.url).toString();


const $7e583ad86f1e8aa8$var$messages = (0, $cgtv4.defineMessages)({
    emptyPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.empty-page-greeting-title",
        defaultMessage: "Start your doc with a prompt"
    }
});
const $7e583ad86f1e8aa8$var$EditPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const editorActions = (0, $02cx8.useEditorRovoButtonActionsActions)();
    const editorActionsContext = (0, $02cx8.useEditorRovoButtonActionsContext)();
    const rovoConfigProviderProps = (0, $amW67.useRovoConfigProviderProps)();
    const isEditorEmpty = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) && rovoConfigProviderProps.isEditorEmpty;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { promptCards: promptCards } = (0, $la9AC.usePromptCards)();
    const isEmptyPageCreationExperimentVariation = isEditorEmpty && Array.isArray(promptCards) && (0, $6mKj3.expVal)('confluence_rovo_button_empty_page_creation_actions', 'cohort', 'not-enrolled') === 'variation';
    const pageProps = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) ? rovoConfigProviderProps : null;
    const contentType = pageProps?.contentType ?? '';
    const contentId = pageProps?.contentId ?? '';
    const enableLiveDocNudges = (0, $23e0c73c9feee0cc$export$5569745b4d0a5343)(contentType, contentId);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const config = (0, $42omo.useMemo)(()=>{
        return {
            getActions: async ()=>{
                if (isEmptyPageCreationExperimentVariation) return Promise.resolve((0, $efb362169c233167$export$4e5c71902381581b)(promptCards));
                if (editorActionsContext?.reference) return Promise.resolve(editorActions);
                const viewPageActions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve([
                    ...editorActions,
                    ...viewPageActions
                ]);
            },
            customGreeting: isEmptyPageCreationExperimentVariation ? {
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($9c464318090b4e27$exports))),
                title: formatMessage($7e583ad86f1e8aa8$var$messages.emptyPageGreetingTitle)
            } : undefined,
            shouldShowGreeting: isEmptyPageCreationExperimentVariation ? true : undefined,
            prioritizeCustomActionResults: isEmptyPageCreationExperimentVariation ? true : undefined
        };
    }, [
        editorActions,
        editorActionsContext,
        viewPageRovoActions,
        isEmptyPageCreationExperimentVariation,
        promptCards,
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        setConfiguration(config);
        if (!enableLiveDocNudges) {
            setNudges([]);
            return;
        }
        const nudges = [
            viewPageRovoActions.find((a)=>a.actionId === 'audio-briefing')?.action
        ].filter(Boolean);
        if (nudges.length > 0) setNudges(nudges);
    }, [
        config,
        setConfiguration,
        enableLiveDocNudges,
        viewPageRovoActions,
        setNudges,
        contentType,
        contentId
    ]);
    return null;
};
const $7e583ad86f1e8aa8$export$d95c465cd9bfae9f = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e583ad86f1e8aa8$var$EditPageConfigProviderInner, props));
};












var $hji5f = parcelRequire("hji5f");











var $gIaMn = parcelRequire("gIaMn");




var $5Abqh = parcelRequire("5Abqh");


const $8a4bdd953279ff48$export$75b705e7e413826a = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "h5GrM",
    name: "AudioButtonLoaderActivatable",
    loader: async ()=>(await (parcelRequire("hFUQ8"))).AudioButton,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AudioButton
});

const $8a4bdd953279ff48$export$2cf028d3aae3c5f9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IJrya",
    name: "AudioButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("hFUQ8"))).AudioButton
});


const $46bbba5af56c1c8e$export$6210e0bba7c89213 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)("confluence_selective_hydration_audio_button", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== contentId || $[3] !== contentTitle || $[4] !== contentType || $[5] !== isDisabled || $[6] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isDisabled
        });
        $[2] = contentId;
        $[3] = contentTitle;
        $[4] = contentType;
        $[5] = isDisabled;
        $[6] = spaceKey;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : (props)=>{
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)('confluence_selective_hydration_audio_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
    // functionality is unchanged, AudioButton is only wrapped in a Loadable
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isDisabled
    });
};
/**
 * Internal component used only when selective hydration is enabled.
 * Contains all SH-specific logic (changeboarding, browser support, keyboard focus unlock).
 *
 * JS for AudioButton is delayed until user hovers (currently for View Page and Space Overviews)
 * Cases for immediate unlock (bypassing selective hydration) include:
 *
 * Changeboarding enabled
 * Disabled browser (Firefox)
 * User activation via keyboard (tab)
 *
 */ const $46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = t0;
    const wrapperRef = (0, $42omo.useRef)(null);
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $42omo.useState)(false);
    const noopOnShow = $46bbba5af56c1c8e$var$_temp;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readTime: readTime } = (0, $h2uld.useReadTime)(contentId);
    const t1 = audioSupportedByBrowser === false;
    let t2;
    if ($[0] !== contentId || $[1] !== readTime || $[2] !== t1) {
        t2 = {
            contentId: contentId,
            onShow: noopOnShow,
            skip: t1,
            readTime: readTime
        };
        $[0] = contentId;
        $[1] = readTime;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const { showChangeboarding: showChangeboarding, handleCloseChangeboarding: handleCloseChangeboarding } = (0, $hji5f.useAudioBriefingChangeboarding)(t2);
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const isAudioSupportedByBrowser = typeof MediaSource !== "undefined" && MediaSource.isTypeSupported("audio/mpeg");
            if (!isAudioSupportedByBrowser) (0, $42omo.startTransition)(()=>{
                setAudioSupportedByBrowser(false);
            });
        };
        t4 = [];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const wrapper = wrapperRef.current;
            if (!wrapper) return;
            const handleFocus = (event)=>{
                const target = event.target;
                if (!target || !target.matches("button, [role=\"button\"]")) return;
                const isKeyboardFocus = target.matches(":focus-visible");
                if (!isKeyboardFocus) return;
                (0, $42omo.startTransition)(()=>{
                    setIsFocusActivated(true);
                });
            };
            wrapper.addEventListener("focus", handleFocus, true);
            return ()=>{
                wrapper.removeEventListener("focus", handleFocus, true);
            };
        };
        t6 = [];
        $[6] = t5;
        $[7] = t6;
    } else {
        t5 = $[6];
        t6 = $[7];
    }
    (0, $42omo.useEffect)(t5, t6);
    const immediateActivationCondition = showChangeboarding || audioSupportedByBrowser === false || isFocusActivated;
    let t7;
    if ($[8] !== audioSupportedByBrowser || $[9] !== isDisabled || $[10] !== renderServerPlaceholder) {
        t7 = isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) || !renderServerPlaceholder && !audioSupportedByBrowser;
        $[8] = audioSupportedByBrowser;
        $[9] = isDisabled;
        $[10] = renderServerPlaceholder;
        $[11] = t7;
    } else t7 = $[11];
    const isButtonDisabled = t7;
    const t8 = audioSupportedByBrowser ?? true;
    let t9;
    if ($[12] !== handleCloseChangeboarding || $[13] !== showChangeboarding || $[14] !== t8) {
        t9 = {
            showChangeboardingFromWrapper: showChangeboarding,
            handleCloseChangeboardingFromWrapper: handleCloseChangeboarding,
            audioSupportedByBrowserFromWrapper: t8
        };
        $[12] = handleCloseChangeboarding;
        $[13] = showChangeboarding;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    const wrapperProps = t9;
    let t10;
    if ($[16] !== contentId || $[17] !== contentTitle || $[18] !== contentType || $[19] !== immediateActivationCondition || $[20] !== isButtonDisabled || $[21] !== spaceKey || $[22] !== wrapperProps) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isButtonDisabled,
            immediateActivationCondition: immediateActivationCondition,
            selectiveHydrationEnabled: true,
            ...wrapperProps
        }));
        $[16] = contentId;
        $[17] = contentTitle;
        $[18] = contentType;
        $[19] = immediateActivationCondition;
        $[20] = isButtonDisabled;
        $[21] = spaceKey;
        $[22] = wrapperProps;
        $[23] = t10;
    } else t10 = $[23];
    return t10;
} : ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    // Assume audio is enabled for SSR until client-side useEffect checks browser support
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $42omo.useState)(false);
    // don't do anything to update state, handle opening inside AudioButton once component hydrates
    const noopOnShow = (0, $42omo.useCallback)(()=>{}, []);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readTime: readTime } = (0, $h2uld.useReadTime)(contentId);
    // Hook is skipped when audio is not supported by browser (same as AudioButton)
    const { showChangeboarding: showChangeboarding, handleCloseChangeboarding: handleCloseChangeboarding } = (0, $hji5f.useAudioBriefingChangeboarding)({
        contentId: contentId,
        onShow: noopOnShow,
        skip: audioSupportedByBrowser === false,
        readTime: readTime
    });
    (0, $42omo.useEffect)(()=>{
        // Only check audio support when selective hydration is enabled.
        // For FG-OFF we rely on the browser check within AudioButton.
        const isAudioSupportedByBrowser = typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg');
        if (!isAudioSupportedByBrowser) (0, $42omo.startTransition)(()=>{
            setAudioSupportedByBrowser(false);
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        // Focus listener to determine if a user has tabbed to the button via keyboard, in which case
        // the component is immediately hydrated. This listener must live outside AudioButton code and hydrate if button is activated.
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const handleFocus = (event)=>{
            const target = event.target;
            if (!target || !target.matches('button, [role="button"]')) return;
            const isKeyboardFocus = target.matches(':focus-visible');
            if (!isKeyboardFocus) return;
            (0, $42omo.startTransition)(()=>{
                setIsFocusActivated(true);
            });
        };
        wrapper.addEventListener('focus', handleFocus, true);
        return ()=>{
            wrapper.removeEventListener('focus', handleFocus, true);
        };
    }, []);
    // Only immediately hydrate if:
    // 1) changeboarding is enabled and the spotlight popper needs to be activated on page load OR
    // 2) audio button is not supported by browser (firefox) and component needs to hydrate to show as disabled on page load
    // 3) user activates the button via keyboard focus
    const immediateActivationCondition = showChangeboarding || audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) || !renderServerPlaceholder && !audioSupportedByBrowser;
    const wrapperProps = {
        showChangeboardingFromWrapper: showChangeboarding,
        handleCloseChangeboardingFromWrapper: handleCloseChangeboarding,
        audioSupportedByBrowserFromWrapper: audioSupportedByBrowser ?? true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isButtonDisabled,
        immediateActivationCondition: immediateActivationCondition,
        selectiveHydrationEnabled: true,
        ...wrapperProps
    }));
};
function $46bbba5af56c1c8e$var$_temp() {}



var $4ZXww = parcelRequire("4ZXww");


var $fgdVB = parcelRequire("fgdVB");


const $3265ee1fae39f7d6$var$CommentPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R3F99",
    name: "CommentPanelButton",
    loader: async ()=>(await (parcelRequire("k7UhM"))).CommentPanelButton
});

const $3265ee1fae39f7d6$var$DetailsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wgj5o",
    name: "DetailsPanelButton",
    loader: async ()=>(await (parcelRequire("9Ima4"))).DetailsPanelButton
});

const $3265ee1fae39f7d6$var$EditorAIActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gSc9d",
    name: "EditorAIActions",
    loader: async ()=>(await (parcelRequire("7rWz7"))).EditorAIActions
});

const $3265ee1fae39f7d6$var$UndoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KP43A",
    name: "UndoButton",
    loader: async ()=>(await (parcelRequire("7K4N2"))).UndoButton
});

const $3265ee1fae39f7d6$var$RedoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jZ8ML",
    name: "RedoButton",
    loader: async ()=>(await (parcelRequire("7K4N2"))).RedoButton
});

const $3265ee1fae39f7d6$var$ShowDiffButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "41USm",
    name: "ShowDiffButton",
    loader: async ()=>(await (parcelRequire("8KEyg"))).ShowDiffButton
});

const $3265ee1fae39f7d6$var$FeedbackCollectorButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "erEzF",
    name: "FeedbackCollectorButton",
    loader: async ()=>(await (parcelRequire("6HPDw"))).FeedbackCollectorButton
});

const $3265ee1fae39f7d6$var$AudioListenButtonWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bAx22",
    name: "AudioListenButtonWrapper",
    loader: async ()=>(await (parcelRequire("7SQUd"))).AudioListenButtonWrapper
});

const $3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hFsXW",
    name: "ObjectSidebarSpotlightTour",
    loader: async ()=>(await (parcelRequire("7mgQ0"))).ObjectSidebarSpotlightTour
});
const $3265ee1fae39f7d6$var$objectSidebarStyles = null;
const $3265ee1fae39f7d6$var$objectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$databaseObjectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$largeBottomPaddingStyles = null;
const $3265ee1fae39f7d6$var$viewModeStylesWithLegacyFooter = null;
const $3265ee1fae39f7d6$var$viewModeStylesWithNewFooter = null;
const $3265ee1fae39f7d6$var$miniModalModeStyles = null;
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleContainerStyles = null;
const $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    marginBottom: 'space.050'
});
const $3265ee1fae39f7d6$var$rovoButtonCollapsibleBottomSidebarStyles = null;
const $3265ee1fae39f7d6$var$collapsibleToggleStyles = null;
const $3265ee1fae39f7d6$var$dividerStyle = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '16px',
    height: '1px'
});
const $3265ee1fae39f7d6$var$hiddenStyles = null;
const $3265ee1fae39f7d6$var$i18n = (0, $cgtv4.defineMessages)({
    expandToggleLabel: {
        id: "object-sidebar-components.expand-toggle-label",
        defaultMessage: "Expand action bar"
    },
    collapseToggleLabel: {
        id: "object-sidebar-components.collapse-toggle-label",
        defaultMessage: "Collapse action bar"
    }
});
const $3265ee1fae39f7d6$export$3fab07431350539e = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(188);
    const { hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, hasAudioButton: hasAudioButton, hasFeedbackButton: t1, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: t2, pageCommentsSectionInView: pageCommentsSectionInView, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: t3, isDatabasesStagingArea: t4, disabled: disabled, isEditorEmpty: isEditorEmpty } = t0;
    const hasFeedbackButton = t1 === undefined ? true : t1;
    const aiIsStreaming = t2 === undefined ? false : t2;
    const shouldDisableUndoRedo = t3 === undefined ? false : t3;
    const isDatabasesStagingArea = t4 === undefined ? false : t4;
    const [t5] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t5;
    let t6;
    if ($[0] !== isCollabOffline) {
        t6 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t6;
    } else t6 = $[1];
    const isNetworkDisabled = t6;
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $42omo.useState)(false);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    let t7;
    if ($[2] !== rightSidebarContext) {
        t7 = rightSidebarContext.getCurrent() || {};
        $[2] = rightSidebarContext;
        $[3] = t7;
    } else t7 = $[3];
    const { width: globalSidebarWidth } = t7;
    const { width: previewPanelWidth } = (0, $3qFIQ.usePreviewPanelsState)();
    const { mode: rovoExperienceMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    let t8;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            selector: $3265ee1fae39f7d6$var$_temp
        };
        $[4] = t8;
    } else t8 = $[4];
    const isOnPDFExportPageRouteArgs = t8;
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t9] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode } = t9;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t10;
    if ($[5] !== setSidebarControlExpandCollapsedState) {
        t10 = ()=>{
            setSidebarControlExpandCollapsedState("expanded");
        };
        $[5] = setSidebarControlExpandCollapsedState;
        $[6] = t10;
    } else t10 = $[6];
    let t11;
    if ($[7] !== contentId || $[8] !== setSidebarControlExpandCollapsedState) {
        t11 = [
            contentId,
            setSidebarControlExpandCollapsedState
        ];
        $[7] = contentId;
        $[8] = setSidebarControlExpandCollapsedState;
        $[9] = t11;
    } else t11 = $[9];
    (0, $42omo.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[10] !== setSidebarControlExpandCollapsedState || $[11] !== setSidebarControlState) {
        t12 = ()=>{
            setSidebarControlState("shown");
            setSidebarControlExpandCollapsedState("expanded");
            return ()=>{
                setSidebarControlExpandCollapsedState("collapsed");
            };
        };
        t13 = [
            setSidebarControlState,
            setSidebarControlExpandCollapsedState
        ];
        $[10] = setSidebarControlExpandCollapsedState;
        $[11] = setSidebarControlState;
        $[12] = t12;
        $[13] = t13;
    } else {
        t12 = $[12];
        t13 = $[13];
    }
    (0, $42omo.useEffect)(t12, t13);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === "expanded" || renderServerPlaceholder;
    let collapsedActions;
    let primaryActions;
    let secondaryActions;
    let secondaryActionsTeam25;
    if ($[14] !== aiIsStreaming || $[15] !== contentId || $[16] !== contentTitle || $[17] !== contentType || $[18] !== disabled || $[19] !== editorAIActions || $[20] !== hasAudioButton || $[21] !== hasCommentsButton || $[22] !== hasDetailsButton || $[23] !== hasFeedbackButton || $[24] !== hasLoomButton || $[25] !== hasUndoRedoButton || $[26] !== isDatabasesStagingArea || $[27] !== isLiveViewMode || $[28] !== isLoomDisabled || $[29] !== isNetworkDisabled || $[30] !== isRovoButtonEnabled || $[31] !== pageMode || $[32] !== shouldDisableUndoRedo || $[33] !== showDiffButtonActions || $[34] !== sidebarIsExpanded || $[35] !== spaceKey || $[36] !== undoRedoButtonActions) {
        collapsedActions = [];
        primaryActions = [];
        if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && (0, $9wGTI.fg)("platform_editor_ai_aifc_streaming") && isDatabasesStagingArea) {
            const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
            if (undo && canUndo !== undefined) {
                const t14 = aiIsStreaming || shouldDisableUndoRedo;
                let t15;
                if ($[41] !== canUndo || $[42] !== t14 || $[43] !== undo) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$UndoButton, {
                        canUndo: canUndo,
                        undo: undo,
                        isDisabled: t14
                    });
                    $[41] = canUndo;
                    $[42] = t14;
                    $[43] = undo;
                    $[44] = t15;
                } else t15 = $[44];
                primaryActions.push(t15);
            }
            if (redo && canRedo !== undefined) {
                const t14 = aiIsStreaming || shouldDisableUndoRedo;
                let t15;
                if ($[45] !== canRedo || $[46] !== redo || $[47] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RedoButton, {
                        canRedo: canRedo,
                        redo: redo,
                        isDisabled: t14
                    });
                    $[45] = canRedo;
                    $[46] = redo;
                    $[47] = t14;
                    $[48] = t15;
                } else t15 = $[48];
                primaryActions.push(t15);
            }
        }
        if (showDiffButtonActions && !isLiveViewMode && (0, $9wGTI.fg)("platform_editor_ai_aifc_streaming") && isDatabasesStagingArea) {
            const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
            const t14 = isShowDiffEnabled && !aiIsStreaming;
            let t15;
            if ($[49] !== isShowDiffSelected || $[50] !== onShowDiff || $[51] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
                    isShowDiffSelected: isShowDiffSelected,
                    isShowDiffEnabled: t14,
                    onShowDiff: onShowDiff
                });
                $[49] = isShowDiffSelected;
                $[50] = onShowDiff;
                $[51] = t14;
                $[52] = t15;
            } else t15 = $[52];
            primaryActions.push(t15);
        }
        secondaryActions = [];
        secondaryActionsTeam25 = [];
        if ((0, $9wGTI.fg)("platform_editor_ai_aifc_streaming")) {
            if (hasCommentsButton) {
                let t14;
                if ($[53] !== contentId || $[54] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[53] = contentId;
                    $[54] = isNetworkDisabled;
                    $[55] = t14;
                } else t14 = $[55];
                secondaryActionsTeam25.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[56] !== contentId || $[57] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                            key: "comment-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[56] = contentId;
                        $[57] = isNetworkDisabled;
                        $[58] = t15;
                    } else t15 = $[58];
                    collapsedActions.push(t15);
                }
            }
            if (hasDetailsButton) {
                let t14;
                if ($[59] !== contentId || $[60] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[59] = contentId;
                    $[60] = isNetworkDisabled;
                    $[61] = t14;
                } else t14 = $[61];
                secondaryActionsTeam25.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[62] !== contentId || $[63] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                            key: "details-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[62] = contentId;
                        $[63] = isNetworkDisabled;
                        $[64] = t15;
                    } else t15 = $[64];
                    collapsedActions.push(t15);
                }
            }
            if (hasAudioButton) {
                if ((0, $6mKj3.isExperimentEnabled)("confluence_audio_v3")) {
                    const t14 = contentType ?? "";
                    const t15 = spaceKey ?? "";
                    const t16 = contentTitle ?? "";
                    let t17;
                    if ($[65] !== contentId || $[66] !== disabled || $[67] !== isRovoButtonEnabled || $[68] !== t14 || $[69] !== t15 || $[70] !== t16) {
                        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                            key: "audio-listen-button-wrapper",
                            isRovoButtonEnabled: isRovoButtonEnabled,
                            contentId: contentId,
                            contentType: t14,
                            spaceKey: t15,
                            title: t16,
                            isAutoOpenDisabled: disabled
                        });
                        $[65] = contentId;
                        $[66] = disabled;
                        $[67] = isRovoButtonEnabled;
                        $[68] = t14;
                        $[69] = t15;
                        $[70] = t16;
                        $[71] = t17;
                    } else t17 = $[71];
                    secondaryActionsTeam25.push(t17);
                } else {
                    const t14 = pageMode === (0, $cD1qu.PageMode).VIEW;
                    let t15;
                    if ($[72] !== contentId || $[73] !== contentTitle || $[74] !== contentType || $[75] !== isNetworkDisabled || $[76] !== spaceKey || $[77] !== t14) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                            key: "audio-button-loader-wrapper",
                            contentId: contentId,
                            contentType: contentType,
                            spaceKey: spaceKey,
                            contentTitle: contentTitle,
                            isDisabled: isNetworkDisabled,
                            isView: t14
                        });
                        $[72] = contentId;
                        $[73] = contentTitle;
                        $[74] = contentType;
                        $[75] = isNetworkDisabled;
                        $[76] = spaceKey;
                        $[77] = t14;
                        $[78] = t15;
                    } else t15 = $[78];
                    secondaryActionsTeam25.push(t15);
                }
            }
            if (hasLoomButton && !isLoomDisabled) {
                const t14 = spaceKey ?? "";
                const t15 = contentType ?? "";
                const t16 = !isRovoButtonEnabled;
                let t17;
                if ($[79] !== contentId || $[80] !== isNetworkDisabled || $[81] !== t14 || $[82] !== t15 || $[83] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                        key: "page-header-loom-entry-point",
                        contentId: contentId,
                        crossSellPopupPlacement: "left-end",
                        crossSellSpotlightPlacement: "left-start",
                        spaceKey: t14,
                        contentType: t15,
                        isCircle: t16,
                        testId: "sidebar-loom-button",
                        source: "contentWrapper",
                        isDisabled: isNetworkDisabled
                    });
                    $[79] = contentId;
                    $[80] = isNetworkDisabled;
                    $[81] = t14;
                    $[82] = t15;
                    $[83] = t16;
                    $[84] = t17;
                } else t17 = $[84];
                secondaryActionsTeam25.push(t17);
            }
            if (editorAIActions) {
                let t14;
                if ($[85] !== aiIsStreaming || $[86] !== editorAIActions) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
                        key: "editor-ai-actions",
                        editorAIActions: editorAIActions,
                        isDisabled: aiIsStreaming
                    });
                    $[85] = aiIsStreaming;
                    $[86] = editorAIActions;
                    $[87] = t14;
                } else t14 = $[87];
                secondaryActionsTeam25.push(t14);
            }
        } else {
            if (hasCommentsButton) {
                let t14;
                if ($[88] !== contentId || $[89] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[88] = contentId;
                    $[89] = isNetworkDisabled;
                    $[90] = t14;
                } else t14 = $[90];
                primaryActions.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[91] !== contentId || $[92] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                            key: "comment-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[91] = contentId;
                        $[92] = isNetworkDisabled;
                        $[93] = t15;
                    } else t15 = $[93];
                    collapsedActions.push(t15);
                }
            }
            if (hasDetailsButton) {
                let t14;
                if ($[94] !== contentId || $[95] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[94] = contentId;
                    $[95] = isNetworkDisabled;
                    $[96] = t14;
                } else t14 = $[96];
                primaryActions.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[97] !== contentId || $[98] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                            key: "details-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[97] = contentId;
                        $[98] = isNetworkDisabled;
                        $[99] = t15;
                    } else t15 = $[99];
                    collapsedActions.push(t15);
                }
            }
            if (hasAudioButton) {
                if ((0, $6mKj3.isExperimentEnabled)("confluence_audio_v3")) {
                    const t14 = contentType ?? "";
                    const t15 = spaceKey ?? "";
                    const t16 = contentTitle ?? "";
                    let t17;
                    if ($[100] !== contentId || $[101] !== disabled || $[102] !== isRovoButtonEnabled || $[103] !== t14 || $[104] !== t15 || $[105] !== t16) {
                        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                            key: "audio-listen-button-wrapper",
                            isRovoButtonEnabled: isRovoButtonEnabled,
                            contentId: contentId,
                            contentType: t14,
                            spaceKey: t15,
                            title: t16,
                            isAutoOpenDisabled: disabled
                        });
                        $[100] = contentId;
                        $[101] = disabled;
                        $[102] = isRovoButtonEnabled;
                        $[103] = t14;
                        $[104] = t15;
                        $[105] = t16;
                        $[106] = t17;
                    } else t17 = $[106];
                    secondaryActions.push(t17);
                } else {
                    const t14 = pageMode === (0, $cD1qu.PageMode).VIEW;
                    let t15;
                    if ($[107] !== contentId || $[108] !== contentTitle || $[109] !== contentType || $[110] !== isNetworkDisabled || $[111] !== spaceKey || $[112] !== t14) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                            key: "audio-button-loader-wrapper",
                            contentId: contentId,
                            contentType: contentType,
                            spaceKey: spaceKey,
                            contentTitle: contentTitle,
                            isDisabled: isNetworkDisabled,
                            isView: t14
                        });
                        $[107] = contentId;
                        $[108] = contentTitle;
                        $[109] = contentType;
                        $[110] = isNetworkDisabled;
                        $[111] = spaceKey;
                        $[112] = t14;
                        $[113] = t15;
                    } else t15 = $[113];
                    secondaryActions.push(t15);
                }
            }
            if (hasLoomButton && !isLoomDisabled) {
                const t14 = spaceKey ?? "";
                const t15 = contentType ?? "";
                const t16 = !isRovoButtonEnabled;
                let t17;
                if ($[114] !== contentId || $[115] !== isNetworkDisabled || $[116] !== t14 || $[117] !== t15 || $[118] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                        key: "page-header-loom-entry-point",
                        contentId: contentId,
                        crossSellPopupPlacement: "left-end",
                        crossSellSpotlightPlacement: "left-start",
                        spaceKey: t14,
                        contentType: t15,
                        isCircle: t16,
                        testId: "sidebar-loom-button",
                        source: "contentWrapper",
                        isDisabled: isNetworkDisabled
                    });
                    $[114] = contentId;
                    $[115] = isNetworkDisabled;
                    $[116] = t14;
                    $[117] = t15;
                    $[118] = t16;
                    $[119] = t17;
                } else t17 = $[119];
                secondaryActions.push(t17);
            }
            if (hasFeedbackButton) {
                let t14;
                if ($[120] !== contentId || $[121] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$FeedbackCollectorButton, {
                        key: "feedback-collector-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[120] = contentId;
                    $[121] = isNetworkDisabled;
                    $[122] = t14;
                } else t14 = $[122];
                secondaryActions.push(t14);
            }
        }
        $[14] = aiIsStreaming;
        $[15] = contentId;
        $[16] = contentTitle;
        $[17] = contentType;
        $[18] = disabled;
        $[19] = editorAIActions;
        $[20] = hasAudioButton;
        $[21] = hasCommentsButton;
        $[22] = hasDetailsButton;
        $[23] = hasFeedbackButton;
        $[24] = hasLoomButton;
        $[25] = hasUndoRedoButton;
        $[26] = isDatabasesStagingArea;
        $[27] = isLiveViewMode;
        $[28] = isLoomDisabled;
        $[29] = isNetworkDisabled;
        $[30] = isRovoButtonEnabled;
        $[31] = pageMode;
        $[32] = shouldDisableUndoRedo;
        $[33] = showDiffButtonActions;
        $[34] = sidebarIsExpanded;
        $[35] = spaceKey;
        $[36] = undoRedoButtonActions;
        $[37] = collapsedActions;
        $[38] = primaryActions;
        $[39] = secondaryActions;
        $[40] = secondaryActionsTeam25;
    } else {
        collapsedActions = $[37];
        primaryActions = $[38];
        secondaryActions = $[39];
        secondaryActionsTeam25 = $[40];
    }
    let t14;
    bb0: {
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) {
            let t15;
            if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
                    provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
                };
                $[123] = t15;
            } else t15 = $[123];
            t14 = t15;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) {
            let t15;
            if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
                    provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
                };
                $[124] = t15;
            } else t15 = $[124];
            t14 = t15;
            break bb0;
        }
        t14 = undefined;
    }
    const rovoConfiguration = t14;
    if (isOnPDFExportPageRoute) return null;
    const globalSidebarMargin = pageMode === (0, $cD1qu.PageMode).VIEW && globalSidebarWidth ? globalSidebarWidth : 0;
    const previewPanelMargin = pageMode === (0, $cD1qu.PageMode).VIEW && previewPanelWidth ? previewPanelWidth : 0;
    let t15;
    if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
        $[125] = t15;
    } else t15 = $[125];
    const isEmbeddedConfluence = t15;
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence;
    const SpotlightTourWrapper = (0, $9wGTI.fg)("cc_modernize_ga_changeboarding") ? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment : (0, $6cnUO.default);
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded;
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    let t16;
    if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setActionBarIsHovered(true);
        };
        $[126] = t16;
    } else t16 = $[126];
    const handleMouseEnter = t16;
    let t17;
    if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = ()=>{
            setActionBarIsHovered(false);
        };
        $[127] = t17;
    } else t17 = $[127];
    const handleMouseLeave = t17;
    let t18;
    if ($[128] !== sidebarIsExpanded || $[129] !== toggleObjectSidebarControl) {
        t18 = ()=>{
            toggleObjectSidebarControl();
            setActionBarIsHovered(!sidebarIsExpanded);
        };
        $[128] = sidebarIsExpanded;
        $[129] = toggleObjectSidebarControl;
        $[130] = t18;
    } else t18 = $[130];
    const onToggleClick = t18;
    let t19;
    if ($[131] !== formatMessage || $[132] !== sidebarIsExpanded) {
        t19 = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[131] = formatMessage;
        $[132] = sidebarIsExpanded;
        $[133] = t19;
    } else t19 = $[133];
    const toggleLabel = t19;
    let t20;
    if ($[134] !== formatMessage) {
        t20 = formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[134] = formatMessage;
        $[135] = t20;
    } else t20 = $[135];
    let t21;
    if ($[136] !== toggleLabel || $[137] !== toggleObjectSidebarControl) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: $3265ee1fae39f7d6$var$_temp2,
            label: toggleLabel,
            onClick: toggleObjectSidebarControl,
            shape: "circle",
            testId: "integrated-expand-button"
        });
        $[136] = toggleLabel;
        $[137] = toggleObjectSidebarControl;
        $[138] = t21;
    } else t21 = $[138];
    let t22;
    if ($[139] !== t20 || $[140] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t20,
            hideTooltipOnClick: true
        }, t21);
        $[139] = t20;
        $[140] = t21;
        $[141] = t22;
    } else t22 = $[141];
    const integratedExpandButton = t22;
    const t23 = "object-sidebar-container";
    const t24 = "object-sidebar-container";
    const t25 = globalSidebarMargin + previewPanelMargin;
    let t26;
    if ($[142] !== t25) {
        t26 = {
            marginRight: t25
        };
        $[142] = t25;
        $[143] = t26;
    } else t26 = $[143];
    const t27 = (0, $gMc0m.default)([
        "_kqsw1n9t _1xi2idpf _94n5idpf _1pbyowjs _lcxvglyw _w1y61wug",
        (contentType === "page" || contentType === "blogpost" || pageMode === (0, $cD1qu.PageMode).VIEW) && "_u5f31ejb _n3tdu2gc",
        contentType === "database" && "_u5f3u2gc _n3tdu2gc",
        largeBottomPadding && "_n3td1ejb",
        isRovoMiniModalShown && "_1pby16oo",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && "_1pbykb7n",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && "_1pbycs5v",
        !renderServerPlaceholder && sidebarControlState === "hidden" && "_1e0cglyw"
    ]);
    let t28;
    if ($[144] !== SpotlightTourWrapper || $[145] !== actionBarIsHovered || $[146] !== collapsedActions || $[147] !== contentId || $[148] !== integratedExpandButton || $[149] !== isMobileApp || $[150] !== isRovoButtonEnabled || $[151] !== onToggleClick || $[152] !== primaryActions || $[153] !== renderServerPlaceholder || $[154] !== secondaryActions || $[155] !== secondaryActionsTeam25 || $[156] !== shouldDisplayHoverToggle || $[157] !== shouldRenderIntegratedExpandButton || $[158] !== shouldRenderWhenEmbedded || $[159] !== sidebarIsExpanded || $[160] !== toggleLabel) {
        t28 = primaryActions.length + secondaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpotlightTourWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $gMc0m.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                    ...iconProps_0,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $3oZ9l.OBJECT_SIDEBAR_SPOTLIGHT_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AnimationWrapper, {
            actionBarIsHovered: actionBarIsHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, (0, $9wGTI.fg)("platform_editor_ai_aifc_streaming") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions))), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, integratedExpandButton) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        })));
        $[144] = SpotlightTourWrapper;
        $[145] = actionBarIsHovered;
        $[146] = collapsedActions;
        $[147] = contentId;
        $[148] = integratedExpandButton;
        $[149] = isMobileApp;
        $[150] = isRovoButtonEnabled;
        $[151] = onToggleClick;
        $[152] = primaryActions;
        $[153] = renderServerPlaceholder;
        $[154] = secondaryActions;
        $[155] = secondaryActionsTeam25;
        $[156] = shouldDisplayHoverToggle;
        $[157] = shouldRenderIntegratedExpandButton;
        $[158] = shouldRenderWhenEmbedded;
        $[159] = sidebarIsExpanded;
        $[160] = toggleLabel;
        $[161] = t28;
    } else t28 = $[161];
    let t29;
    if ($[162] !== contentId || $[163] !== contentTitle || $[164] !== contentType || $[165] !== isEditorEmpty || $[166] !== isLivePage || $[167] !== isNetworkDisabled || $[168] !== isRovoButtonEnabled || $[169] !== isUnpublishedDraft || $[170] !== lastModifiedDate || $[171] !== pageCommentsSectionInView || $[172] !== pageMode || $[173] !== rovoConfiguration?.experience || $[174] !== rovoConfiguration?.provider || $[175] !== shouldRenderAISmartButton || $[176] !== spaceKey) {
        t29 = shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_ca0qu2gc _otyrpxbi _18u0t94y"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3tUdX.RovoConfigProvider), {
            experience: rovoConfiguration?.experience,
            provider: rovoConfiguration?.provider,
            contentId: contentId,
            contentType: contentType ?? "",
            spaceKey: spaceKey ?? "",
            contentTitle: contentTitle ?? "",
            lastModifiedDate: lastModifiedDate,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
            contentId: contentId,
            contentType: contentType ?? "",
            pageMode: pageMode,
            isDisabled: isNetworkDisabled
        })) : contentType !== "database" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIQbF.AIFloatingContextMenu), {
            spaceKey: spaceKey ?? "",
            contentId: contentId,
            contentType: contentType ?? "",
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isLivePage: isLivePage,
            isInObjectSideBar: true
        })));
        $[162] = contentId;
        $[163] = contentTitle;
        $[164] = contentType;
        $[165] = isEditorEmpty;
        $[166] = isLivePage;
        $[167] = isNetworkDisabled;
        $[168] = isRovoButtonEnabled;
        $[169] = isUnpublishedDraft;
        $[170] = lastModifiedDate;
        $[171] = pageCommentsSectionInView;
        $[172] = pageMode;
        $[173] = rovoConfiguration?.experience;
        $[174] = rovoConfiguration?.provider;
        $[175] = shouldRenderAISmartButton;
        $[176] = spaceKey;
        $[177] = t29;
    } else t29 = $[177];
    let t30;
    if ($[178] !== handleMouseEnter || $[179] !== handleMouseLeave || $[180] !== t26 || $[181] !== t27 || $[182] !== t28 || $[183] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": t23,
            "data-vc": t24,
            style: t26,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            className: t27
        }, t28, t29);
        $[178] = handleMouseEnter;
        $[179] = handleMouseLeave;
        $[180] = t26;
        $[181] = t27;
        $[182] = t28;
        $[183] = t29;
        $[184] = t30;
    } else t30 = $[184];
    let t31;
    if ($[185] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[185] = t31;
    } else t31 = $[185];
    let t32;
    if ($[186] !== t30) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t30, t31);
        $[186] = t30;
        $[187] = t32;
    } else t32 = $[187];
    return t32;
} : ({ hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, hasAudioButton: hasAudioButton, hasFeedbackButton: hasFeedbackButton = true, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: aiIsStreaming = false, pageCommentsSectionInView: pageCommentsSectionInView, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: shouldDisableUndoRedo = false, isDatabasesStagingArea: isDatabasesStagingArea = false, disabled: disabled, isEditorEmpty: isEditorEmpty })=>{
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $42omo.useState)(false);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { width: globalSidebarWidth } = rightSidebarContext.getCurrent() || {};
    const { width: previewPanelWidth } = (0, $3qFIQ.usePreviewPanelsState)();
    const { mode: rovoExperienceMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isOnPDFExportPageRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
        }
    };
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // whenever the contentID changes we needed to reset the action bar to be expanded
    (0, $42omo.useEffect)(()=>{
        setSidebarControlExpandCollapsedState('expanded');
    }, [
        contentId,
        setSidebarControlExpandCollapsedState
    ]);
    (0, $42omo.useEffect)(()=>{
        setSidebarControlState('shown');
        setSidebarControlExpandCollapsedState('expanded');
        return ()=>{
            setSidebarControlExpandCollapsedState('collapsed');
        };
    }, [
        setSidebarControlState,
        setSidebarControlExpandCollapsedState
    ]);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === 'expanded' || renderServerPlaceholder; // Collapsed actions are rendered when collapsed. These can be used e.g. to enable keyboard shortcuts while collapsed.
    const collapsedActions = [];
    const primaryActions = [];
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming') && isDatabasesStagingArea) {
        const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
        if (undo && canUndo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$UndoButton, {
            canUndo: canUndo,
            undo: undo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
        if (redo && canRedo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RedoButton, {
            canRedo: canRedo,
            redo: redo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
    }
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    showDiffButtonActions && !isLiveViewMode && (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming') && isDatabasesStagingArea) {
        const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
        primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
            isShowDiffSelected: isShowDiffSelected,
            isShowDiffEnabled: isShowDiffEnabled && !aiIsStreaming,
            onShowDiff: onShowDiff
        }));
    }
    const secondaryActions = [];
    const secondaryActionsTeam25 = [];
    if ((0, $9wGTI.fg)('platform_editor_ai_aifc_streaming')) {
        if (hasCommentsButton) {
            secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasDetailsButton) {
            secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasAudioButton) {
            if ((0, $6mKj3.isExperimentEnabled)('confluence_audio_v3')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                key: "audio-listen-button-wrapper",
                isRovoButtonEnabled: isRovoButtonEnabled,
                contentId: contentId,
                contentType: contentType ?? '',
                spaceKey: spaceKey ?? '',
                title: contentTitle ?? '',
                isAutoOpenDisabled: disabled
            }));
            else secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                key: "audio-button-loader-wrapper",
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                contentTitle: contentTitle,
                isDisabled: isNetworkDisabled,
                isView: pageMode === (0, $cD1qu.PageMode).VIEW
            }));
        }
        if (hasLoomButton && !isLoomDisabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            key: "page-header-loom-entry-point",
            contentId: contentId,
            crossSellPopupPlacement: "left-end",
            crossSellSpotlightPlacement: "left-start",
            spaceKey: spaceKey ?? '',
            contentType: contentType ?? '',
            isCircle: !isRovoButtonEnabled,
            testId: "sidebar-loom-button",
            source: "contentWrapper",
            isDisabled: isNetworkDisabled
        }));
        if (editorAIActions) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
            key: "editor-ai-actions",
            editorAIActions: editorAIActions,
            isDisabled: aiIsStreaming
        }));
    } else {
        if (hasCommentsButton) {
            primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasDetailsButton) {
            primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasAudioButton) {
            if ((0, $6mKj3.isExperimentEnabled)('confluence_audio_v3')) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                key: "audio-listen-button-wrapper",
                isRovoButtonEnabled: isRovoButtonEnabled,
                contentId: contentId,
                contentType: contentType ?? '',
                spaceKey: spaceKey ?? '',
                title: contentTitle ?? '',
                isAutoOpenDisabled: disabled
            }));
            else secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                key: "audio-button-loader-wrapper",
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                contentTitle: contentTitle,
                isDisabled: isNetworkDisabled,
                isView: pageMode === (0, $cD1qu.PageMode).VIEW
            }));
        }
        if (hasLoomButton && !isLoomDisabled) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            key: "page-header-loom-entry-point",
            contentId: contentId,
            crossSellPopupPlacement: "left-end",
            crossSellSpotlightPlacement: "left-start",
            spaceKey: spaceKey ?? '',
            contentType: contentType ?? '',
            isCircle: !isRovoButtonEnabled,
            testId: "sidebar-loom-button",
            source: "contentWrapper",
            isDisabled: isNetworkDisabled
        }));
        if (hasFeedbackButton) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$FeedbackCollectorButton, {
            key: "feedback-collector-button",
            contentId: contentId,
            isDisabled: isNetworkDisabled
        }));
    }
    const rovoConfiguration = (0, $42omo.useMemo)(()=>{
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
            provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
        };
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
            provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
        };
        return undefined;
    }, [
        pageMode,
        isLiveViewMode
    ]);
    if (isOnPDFExportPageRoute) return null;
    const globalSidebarMargin = pageMode === (0, $cD1qu.PageMode).VIEW && globalSidebarWidth ? globalSidebarWidth : 0;
    const previewPanelMargin = pageMode === (0, $cD1qu.PageMode).VIEW && previewPanelWidth ? previewPanelWidth : 0;
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(); // For databases in staging area, always allow rendering (isFullScreenEmbedView is typically undefined)
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence; // Remove <SpotlightManager> on top of `ObjectSidebarSpotlightTour`  when FG `cc_modernize_ga_changeboarding` is enabled
    // This will allow the `ModernizeChangeboarding` component to have combined spollight tour managed by the <SpotlightManager> in `PageLayout`
    // We still keep the <SpotlightManager> in place for existing Live Doc changeboarding EAP and Open beta users.
    // We will remove `SpotlightManager` in this file when FG `cc_modernize_ga_changeboarding` is rolled out
    const SpotlightTourWrapper = (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment : (0, $6cnUO.default); // If there's no AI button, when we collapse the action bar, we need to render an expand icon within the
    // existing action bar container. If there is an AI button, hovering over it should render the expand icon
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded; // We always render the toggle component into the DOM, but we change its visibility based on:
    // If the action bar is expanded: show on hover (regardless of AI button)
    // If the action bar is collapsed: always show if AI button present, otherwise never show
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    const handleMouseEnter = ()=>{
        setActionBarIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setActionBarIsHovered(false);
    };
    const onToggleClick = ()=>{
        toggleObjectSidebarControl(); // need to make sure the hover (dis)appears after clicking it
        setActionBarIsHovered(!sidebarIsExpanded);
    };
    const toggleLabel = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
    const integratedExpandButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps,
                size: "small"
            }),
        label: toggleLabel,
        onClick: toggleObjectSidebarControl,
        shape: "circle",
        testId: "integrated-expand-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "object-sidebar-container",
        "data-vc": "object-sidebar-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: globalSidebarMargin + previewPanelMargin
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _1xi2idpf _94n5idpf _1pbyowjs _lcxvglyw _w1y61wug",
            (contentType === 'page' || contentType === 'blogpost' || pageMode === (0, $cD1qu.PageMode).VIEW) && "_u5f31ejb _n3tdu2gc",
            contentType === 'database' && "_u5f3u2gc _n3tdu2gc",
            largeBottomPadding && "_n3td1ejb",
            isRovoMiniModalShown && "_1pby16oo",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_1pbykb7n",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_1pbycs5v",
            !renderServerPlaceholder && sidebarControlState === 'hidden' && "_1e0cglyw"
        ])
    }, primaryActions.length + secondaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpotlightTourWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps_0,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $3oZ9l.OBJECT_SIDEBAR_SPOTLIGHT_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AnimationWrapper, {
        actionBarIsHovered: actionBarIsHovered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions))), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, integratedExpandButton) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }))), shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_ca0qu2gc _otyrpxbi _18u0t94y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: rovoConfiguration?.experience,
        provider: rovoConfiguration?.provider,
        contentId: contentId,
        contentType: contentType ?? '',
        spaceKey: spaceKey ?? '',
        contentTitle: contentTitle ?? '',
        lastModifiedDate: lastModifiedDate,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
        contentId: contentId,
        contentType: contentType ?? '',
        pageMode: pageMode,
        isDisabled: isNetworkDisabled
    })) : contentType !== 'database' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIQbF.AIFloatingContextMenu), {
        spaceKey: spaceKey ?? '',
        contentId: contentId,
        contentType: contentType ?? '',
        lastModifiedDate: lastModifiedDate,
        pageCommentsSectionInView: pageCommentsSectionInView,
        isLivePage: isLivePage,
        isInObjectSideBar: true
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }));
});
const $3265ee1fae39f7d6$var$AnimationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, actionBarIsHovered: actionBarIsHovered } = t0;
    if ((0, $6mKj3.expValEquals)("cc-motion-survey-experiment", "cohort", "experiment")) {
        let t1;
        if ($[0] !== actionBarIsHovered || $[1] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6260267e05cdfdb2$export$2e2bcd8739ae039), {
                duration: "medium",
                enteringAnimation: "fade-in-from-bottom",
                exitingAnimation: "fade-out-from-top",
                animationTimingFunction: "ease-in-40-out"
            }, (animateProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    ...actionBarIsHovered ? animateProps : {},
                    "data-testid": "action-bar-animation-wrapper"
                }, children));
            $[0] = actionBarIsHovered;
            $[1] = children;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, actionBarIsHovered: actionBarIsHovered })=>{
    if ((0, $6mKj3.expValEquals)('cc-motion-survey-experiment', 'cohort', 'experiment')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6260267e05cdfdb2$export$2e2bcd8739ae039), {
        duration: "medium",
        enteringAnimation: "fade-in-from-bottom",
        exitingAnimation: "fade-out-from-top",
        animationTimingFunction: "ease-in-40-out"
    }, (animateProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...actionBarIsHovered ? animateProps : {},
            "data-testid": "action-bar-animation-wrapper"
        }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
function $3265ee1fae39f7d6$var$_temp(routeName) {
    if (!routeName) return false;
    return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
}
function $3265ee1fae39f7d6$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ObjectSidebarControl"] = $3265ee1fae39f7d6$export$3fab07431350539e;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("8unJx", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $kPbXZ = parcelRequire("kPbXZ");

const $d1d2403974de0af3$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true
};
const $d1d2403974de0af3$var$store = (0, $1P1Tu.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $d1d2403974de0af3$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($d1d2403974de0af3$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $d1d2403974de0af3$var$useStore = (0, $9zUhf.createHook)($d1d2403974de0af3$var$store);
const $d1d2403974de0af3$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable }, { reset: reset, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $d1d2403974de0af3$var$useStore();
    return {
        mode: mode,
        reset: reset,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $d1d2403974de0af3$export$66cf76b7e04da11f = (0, $9zUhf.createActionsHook)($d1d2403974de0af3$var$store);
module.exports["useRovoExperienceAPIStore"] = $d1d2403974de0af3$export$37440b51449f7ac6;

});

parcelRegister("kPbXZ", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $053d47555d884138$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $053d47555d884138$export$bc36ebf73899a71d;

});

parcelRegister("hR4U4", function(module, exports) {
const $991dc85317754fda$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $991dc85317754fda$export$bc36ebf73899a71d;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $9wGTI.fg)("use_frontend_feature_encoding_sdk") ? (0, $5spQU.isFeatureEnabled)("confluence", "confluence-loom-integration") : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    // When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
    const isLoomFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration') : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("dWpd3", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $eb4732679a1ccd43$var$initialState = {
    activeContent: null,
    eligibleForChangeboarding: false
};
const $eb4732679a1ccd43$var$actions = {
    setActiveContent: (activeContent)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                activeContent: activeContent
            });
        },
    setEligibleForChangeboarding: (eligibleForChangeboarding)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                eligibleForChangeboarding: eligibleForChangeboarding
            });
        }
};
const $eb4732679a1ccd43$var$AudioButtonWrapperStore = (0, $1P1Tu.createStore)({
    name: 'AudioButtonWrapperStore',
    initialState: $eb4732679a1ccd43$var$initialState,
    actions: $eb4732679a1ccd43$var$actions
});
const $eb4732679a1ccd43$export$ab1ee966cd621cb0 = (0, $9zUhf.createStateHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore, {
    selector: (state)=>({
            activeContent: state.activeContent,
            eligibleForChangeboarding: state.eligibleForChangeboarding
        })
});
const $eb4732679a1ccd43$export$9980b31ff728dec1 = (0, $9zUhf.createActionsHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore);
module.exports["useAudioButtonWrapperStore"] = $eb4732679a1ccd43$export$ab1ee966cd621cb0;
module.exports["useAudioButtonWrapperActions"] = $eb4732679a1ccd43$export$9980b31ff728dec1;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New comments data manager - get processed data from the store
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // ActiveCommentsQuery implementation - used when cc_comments_new_comments_data_manager is disabled
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentType.INLINE and CommentType.FOOTER)
        skip: !contentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    return (0, $42omo.useMemo)(()=>{
        // Priority 1: Use new comments data manager when enabled
        if (processedCommentsData.isDataProcessed && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            const unresolvedInlineCommentsCount = processedCommentsData.openInlineComments.length;
            const footerCommentsCount = processedCommentsData.openFooterComments.length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 2: Use ActiveCommentsQuery when cc_comments_new_comments_data_manager is disabled
        if (allCommentsData?.comments?.nodes && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'INLINE').length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'FOOTER').length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 3: Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        processedCommentsData.isDataProcessed,
        processedCommentsData.openInlineComments.length,
        processedCommentsData.openFooterComments.length,
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("aPT9H", function(module, exports) {
/**
 * @graphql cc
 */ 
var $j1Ss3 = parcelRequire("j1Ss3");


var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $l5y3Y = parcelRequire("l5y3Y");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !contentId
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate or experiment is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("ftXPY", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $eSUdr.default)`query CommentsSectionQuery($offset:String$first:Long$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $eSUdr.default)`query CommentsSectionWithoutReactionsQuery($offset:String$first:Long$contentId:ID!){comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("afBrg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e818db41afcf6fce742cecb9d4361e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $776858abadb4b212$var$_react = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("42omo")));

var $776858abadb4b212$var$_baseNew = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $776858abadb4b212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $776858abadb4b212$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $776858abadb4b212$var$_react.default.createElement($776858abadb4b212$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$776858abadb4b212$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $776858abadb4b212$var$_default = module.exports.default = $776858abadb4b212$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $4c47f75c6ef52bb8$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_PULL_REQUEST_WITHOUT_PIPELINES_STARTERS"] = "bitbucket-pull-request-without-pipelines-starters";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["STORE_HOME"] = "store-home";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $4c47f75c6ef52bb8$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $4c47f75c6ef52bb8$export$c91e07269f22915a;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $4c47f75c6ef52bb8$export$4f757e7d9540e8f9;

});

parcelRegister("2bR8c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $42omo.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("auLW1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b253f08be2669ace$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wRZLE",
    name: "PageCatchupComponent",
    loader: async ()=>(await (parcelRequire("bUUzz"))).PageCatchupComponentWithErrorBoundary
});
module.exports["PageCatchupComponent"] = $b253f08be2669ace$export$c463287b61deee24;

});

parcelRegister("bUUzz", function(module, exports) {

let $8ad0ced744ee6c35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ad0ced744ee6c35$var$load("7inDN"),
    $8ad0ced744ee6c35$var$load("6wr18"),
    $8ad0ced744ee6c35$var$load("8VT23"),
    $8ad0ced744ee6c35$var$load("ffEVr"),
    $8ad0ced744ee6c35$var$load("hhss7"),
    $8ad0ced744ee6c35$var$load("eN6nL")
]).then(()=>parcelRequire('4RbVT'));

});

parcelRegister("h2uld", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $j25oo = parcelRequire("j25oo");


var $jtuBN = parcelRequire("jtuBN");


var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $8b6571c5cd7e604c$export$9a0a69714186a2dc = (0, $j25oo.default);
const $8b6571c5cd7e604c$export$bf3941b9bff5380a = (contentId, skipQuery)=>{
    const $ = (0, $frIzR.c)(20);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== skipQuery || $[3] !== t0) {
        t1 = {
            variables: t0,
            skip: skipQuery
        };
        $[2] = skipQuery;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const readTimeQueryOptions = t1;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($8b6571c5cd7e604c$export$9a0a69714186a2dc, readTimeQueryOptions);
    let t2;
    if ($[5] !== contentId || $[6] !== data || $[7] !== error || $[8] !== loading) {
        bb0: {
            const adfFromData = (0, $72md5.getAdf)(data ?? undefined);
            if (!adfFromData || loading || error || !contentId) {
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = {
                        readTime: null,
                        wordCount: null,
                        features: null,
                        featuresSkipExpand: null
                    };
                    $[10] = t3;
                } else t3 = $[10];
                t2 = t3;
                break bb0;
            }
            t2 = {
                adf: adfFromData,
                readTime: (0, $72md5.calculateEstimatedReadTime)(adfFromData),
                wordCount: (0, $72md5.getWordCount)(adfFromData),
                features: (0, $h3vPv.extractContentFeatures)(adfFromData),
                featuresSkipExpand: (0, $h3vPv.extractContentFeaturesSkipExpand)(adfFromData)
            };
        }
        $[5] = contentId;
        $[6] = data;
        $[7] = error;
        $[8] = loading;
        $[9] = t2;
    } else t2 = $[9];
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = t2;
    const contentNode = data?.content?.nodes?.[0];
    const contentType = contentNode?.type;
    let t3;
    if ($[11] !== adf || $[12] !== contentType || $[13] !== error || $[14] !== features || $[15] !== featuresSkipExpand || $[16] !== loading || $[17] !== readTime || $[18] !== wordCount) {
        t3 = {
            loading: loading,
            error: error,
            adf: adf,
            contentType: contentType,
            readTime: readTime,
            wordCount: wordCount,
            features: features,
            featuresSkipExpand: featuresSkipExpand
        };
        $[11] = adf;
        $[12] = contentType;
        $[13] = error;
        $[14] = features;
        $[15] = featuresSkipExpand;
        $[16] = loading;
        $[17] = readTime;
        $[18] = wordCount;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
};
module.exports["ReadTimeQuery"] = $8b6571c5cd7e604c$export$9a0a69714186a2dc;
module.exports["useReadTime"] = $8b6571c5cd7e604c$export$bf3941b9bff5380a;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<73e6f733cbfadb69e70ae427aebee2a1>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("72md5", function(module, exports) {

var $h3vPv = parcelRequire("h3vPv");

const $7a7682e083b4bc67$var$wpm = 265; // words per minute, inspired by Medium.com
const $7a7682e083b4bc67$var$minute = 60;
const $7a7682e083b4bc67$export$dbd433271872c208 = (imageCount)=>{
    let readTime = 0;
    for(let i = 0; i < imageCount; i++)readTime += Math.max(12 - i, 3);
    return readTime;
};
const $7a7682e083b4bc67$export$a44553c2ca45b9b3 = (adf)=>{
    if (adf) {
        const extractedFeatures = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
        const features = extractedFeatures;
        const readTime = (features.wordCount / $7a7682e083b4bc67$var$wpm * 60 + $7a7682e083b4bc67$export$dbd433271872c208(features.imageCount)) / $7a7682e083b4bc67$var$minute;
        if (readTime > 0.5) return Math.round(readTime);
    }
    return 0;
};
const $7a7682e083b4bc67$export$da369a1128d64cc6 = (response)=>{
    const representation = response?.content?.nodes?.[0]?.body?.dynamic?.representation;
    if (representation === 'atlas_doc_format') {
        const adfString = response?.content?.nodes?.[0]?.body?.dynamic?.value;
        if (adfString) try {
            return JSON.parse(adfString);
        } catch  {
            return null;
        }
    }
    return null;
};
const $7a7682e083b4bc67$export$d7ca718a8dbe1f35 = ({ contentType: contentType, contentId: contentId, adf: adf, isInEditor: isInEditor })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence-frontend',
            action: 'extracted',
            actionSubject: 'contentFeature',
            objectType: contentType,
            objectId: contentId,
            attributes: {
                ...(0, $h3vPv.extractContentFeatures)(adf),
                isInEditor: isInEditor
            }
        }
    });
const $7a7682e083b4bc67$export$dba3e2bcdbd49da4 = (adf)=>{
    if (!adf) return 0;
    const features = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return features.wordCount;
};
module.exports["calculateImageReadTime"] = $7a7682e083b4bc67$export$dbd433271872c208;
module.exports["calculateEstimatedReadTime"] = $7a7682e083b4bc67$export$a44553c2ca45b9b3;
module.exports["getAdf"] = $7a7682e083b4bc67$export$da369a1128d64cc6;
module.exports["getContentFeatureExtractedEventObject"] = $7a7682e083b4bc67$export$d7ca718a8dbe1f35;
module.exports["getWordCount"] = $7a7682e083b4bc67$export$dba3e2bcdbd49da4;

});

parcelRegister("h3vPv", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

// helper function to traverse ADF tree while skipping expand nodes
const $a8469c4e0ee76bb2$var$reduceSkipExpand = (node, reducer, initialValue)=>{
    // skip if this is an expand node
    if (node.type === 'expand' || node.type === 'nestedExpand') return initialValue;
    // process current node
    let result = reducer(initialValue, node);
    // process child nodes if they exist
    if (node.content) result = node.content.reduce((acc, child)=>$a8469c4e0ee76bb2$var$reduceSkipExpand(child, reducer, acc), result);
    return result;
};
const $a8469c4e0ee76bb2$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $a8469c4e0ee76bb2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $a8469c4e0ee76bb2$var$wordCount(node.text)
            };
        case 'media':
            return {
                ...currentValue,
                imageCount: currentValue.imageCount + 1,
                mediaFiles: node.attrs?.type === 'file' && node.attrs?.id ? currentValue.mediaFiles.concat(node.attrs.id) : currentValue.mediaFiles
            };
        case 'inlineExtension':
            return {
                ...currentValue,
                inlineMacroCount: currentValue.macroCount + 1
            };
        case 'extension':
            return {
                ...currentValue,
                macroCount: currentValue.macroCount + 1
            };
        case 'table':
            return {
                ...currentValue,
                tableCount: currentValue.tableCount + 1
            };
        case 'embedCard':
            const url = node.attrs?.url;
            if (!url.includes('loom')) return currentValue;
            const videoId = url?.split('/').pop().split('?')[0];
            return {
                ...currentValue,
                looms: videoId ? currentValue.looms.concat({
                    id: videoId,
                    url: url
                }) : currentValue.looms
            };
    }
    return currentValue;
};
const $a8469c4e0ee76bb2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$export$8e18062037dcc9dd = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return $a8469c4e0ee76bb2$var$reduceSkipExpand(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $a8469c4e0ee76bb2$export$a148305df2eb5487;
module.exports["extractContentFeaturesSkipExpand"] = $a8469c4e0ee76bb2$export$8e18062037dcc9dd;

});

parcelRegister("la9AC", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $08b97b2e27a84eff$var$PROMPT_CATEGORIES = [
    'Analyze',
    'Brainstorm',
    'Review',
    'Summarize',
    'Create',
    'Execute',
    'Find',
    'Learn'
];
const $08b97b2e27a84eff$var$PROMPT_ROLES = [
    'General',
    'Engineering',
    'Product',
    'Program Management',
    'Design',
    'Marketing',
    'IT Ops',
    'Sales',
    'Customer Support',
    'Helpdesk Support',
    'Security'
];
const $08b97b2e27a84eff$var$createFilterOptions = (values)=>values.map((value)=>({
            id: value,
            label: value
        }));
const $08b97b2e27a84eff$export$9fa6e712ef03097f = $08b97b2e27a84eff$var$createFilterOptions($08b97b2e27a84eff$var$PROMPT_CATEGORIES);
const $08b97b2e27a84eff$export$9472c6a87dde5170 = $08b97b2e27a84eff$var$createFilterOptions($08b97b2e27a84eff$var$PROMPT_ROLES);
const $08b97b2e27a84eff$var$PROMPT_LIBRARY_SKILL_TAG = 'rovo-chat-prompt-gallery';
// Pattern for prompt-library skill tag syntax: '/slug' (quoted).
const $08b97b2e27a84eff$var$PROMPT_LIBRARY_SKILL_TAG_PATTERN_TEST = /'\/[a-zA-Z0-9-]+'/;
const $08b97b2e27a84eff$export$9957a153ee0b4061 = (prompt)=>$08b97b2e27a84eff$var$PROMPT_LIBRARY_SKILL_TAG_PATTERN_TEST.test(prompt);
// Prompts with multiple placeholders are commented out until they are supported by this
// PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/217105
const $08b97b2e27a84eff$var$staticPrompts = [
    {
        id: 'analyze-customer-feedback-trends',
        title: 'Analyze customer feedback trends',
        prompt: 'Gather and synthesize customer feedback on `product/feature` from various channels such as emails, calls, surveys, support tickets to identify key themes, pain points, opportunities such as upsell and adoption, and organize findings into actionable recommendations. If relevant, map them to stages of the customer journey.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Program Management',
            'Customer Support',
            'Sales'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'analyze-it-support-trends',
    // 	title: 'Analyze Trends in IT Support Requests',
    // 	prompt:
    // 		'Examine all IT support requests related to `request type` from the past `number of months` months. Break down the request type by identifying the most common sub-categories and providing counts for each. Investigate resolution notes or agent comments to uncover recurring root causes behind these issues. Identify any time-based patterns, such as spikes in requests during specific times of day, days of the week, or months. Based on your findings, recommend actionable strategies to effectively reduce the volume of this request type.',
    // 	useCase: 'Analyze',
    // 	roles: ['Helpdesk Support', 'IT Ops', 'Customer Support', 'Program Management'],
    // },
    {
        id: 'brainstorm-project-ideas',
        title: 'Brainstorm ideas for project',
        prompt: "We're running a brainstorming session on `topic/problem/goal`. Generate a diverse list of creative ideas, solutions, and/or approaches. For each idea, include a brief description, potential benefits, and any risks or challenges. Organize the ideas by theme or category if possible.",
        useCase: 'Brainstorm',
        roles: [
            'General'
        ]
    },
    {
        id: 'compare-jira-support-article',
        title: 'Compare Jira work item to support article',
        prompt: 'Review the summary, description, and comments of the current request `work item ID`. Based on this information and considering common themes from recently resolved requests, determine if this issue points to a recurring problem that currently lacks a dedicated knowledge base article. If so, propose a concise title for a new knowledge base article and 2-3 key topics or resolution steps it should cover. This should be a distinct problem, not a minor variation of an existing knowledge base article.',
        useCase: 'Review',
        roles: [
            'Helpdesk Support',
            'Customer Support',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'conduct-competitive-research',
    // 	title: 'Conduct competitive research',
    // 	prompt:
    // 		'Analyze the competitive landscape for `product` against `Competitor A, B, C, and D` by comparing features, pricing, market positioning, and strengths. Identify market gaps for `product` to explore. Summarize findings in a narrative, including a comparison matrix.',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management', 'Marketing', 'Sales'],
    // },
    {
        id: 'convert-request-jql-query',
        title: 'Convert request into JQL query',
        prompt: 'Write a JQL query to find all unresolved bugs assigned to my team in the last 30 days.',
        useCase: 'Execute',
        roles: [
            'Engineering',
            'Product',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'create-jira-work-item-summaries',
    // 	title: 'Create a document of Jira work item summaries',
    // 	prompt:
    // 		'Generate a Confluence page summarizing information in these work items: `work item ID(s)`.',
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Program Management', 'Engineering', 'Customer Support'],
    // },
    // {
    // 	id: 'create-new-sprint',
    // 	title: 'Create a new sprint',
    // 	prompt:
    // 		'Create a new sprint named `sprint name` on the board: `board key`. Set the sprint goal to `sprint goal`, start date to `YYYY-MM-DD`, and end date to `YYYY-MM-DD`.',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'create-ab-testing-plan',
        title: 'Create A/B testing plan',
        prompt: 'Create a detailed A/B testing plan for `project/feature`. Start by defining the hypothesis and primary goal, specifying the variants to be tested, and identifying the key metric(s) for success. Outline the target audience and sample size, describe how users will be randomly assigned to each group, and set the test duration and timeline. Include steps for implementation, data collection, and analysis, and note any tools or platforms to be used. Finally, add placeholders for documenting results, learnings, and next steps, ensuring the plan is clear, actionable, and easy to adapt for different experiments, with space for users to add or modify details as needed.',
        useCase: 'Create',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Design'
        ]
    },
    // {
    // 	id: 'create-effective-okr',
    // 	title: 'Create an effective OKR',
    // 	prompt: 'Help me create an effective OKR for my team.',
    // 	useCase: 'Create',
    // 	roles: ['General', 'Product', 'Program Management'],
    // },
    {
        id: 'create-background-research-plan',
        title: 'Create background research plan',
        prompt: 'Create a first draft or conduct background research on `topic/work item`. Summarise key points, relevant history, and provide links to supporting documents.',
        useCase: 'Summarize',
        roles: [
            'Product',
            'Program Management',
            'Engineering',
            'Design'
        ]
    },
    {
        id: 'create-customer-onboarding-strategy',
        title: 'Create customer onboarding strategy',
        prompt: 'As a customer success lead, outline a clear customer onboarding strategy for `product or service`, including key objectives, main onboarding steps, communication touchpoints, and success metrics; highlight best practices for activation and engagement, and provide space for users to add project-specific details or adapt the strategy for different customer segments, ensuring the plan is concise, actionable, and easy to share with stakeholders.',
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Sales',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'create-jira-work-item',
    // 	title: 'Create Jira work item',
    // 	prompt:
    // 		'Create a Jira work item in project `project key` with work type as `bug/task/story/epic`, status as TO DO, classification level as project default, and the summary "`summary`."',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'IT Ops', 'Customer Support'],
    // },
    // {
    // 	id: 'create-meeting-agenda',
    // 	title: 'Create meeting agenda',
    // 	prompt:
    // 		'Create a `number of minutes/hours` meeting agenda with `person/team/department` on `meeting topic` to discuss `objectives for the meeting`. Based on these objectives, suggest key topics, allocate appropriate time for each, and list any supporting materials needed.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-personalized-onboarding-plan',
    // 	title: 'Create personalized onboarding plan',
    // 	prompt:
    // 		'Create a 30-day plan to help me get up to speed. I am onboarding onto `team` as a `role`. Include learning resources, team priorities, key contacts, and engagement strategies.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-presentation-outline',
    // 	title: 'Create presentation outline',
    // 	prompt:
    // 		'Outline a talk track for a presentation targeting `company/product` clients in the `sector` to educate them on the `solution`. Ensure the talk track is clear, informative, and formatted with timestamps in a table.',
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    // {
    // 	id: 'create-pricing-model-customers',
    // 	title: 'Create pricing model for customers',
    // 	prompt:
    // 		'Generate a pricing model for `customer/product` using the latest customer data. Include scenario analysis and pricing plan comparisons.',
    // 	useCase: 'Create',
    // 	roles: ['Sales', 'Product', 'Marketing'],
    // },
    {
        id: 'create-product-requirements-document',
        title: 'Create product requirements document',
        prompt: 'Draft a PRD for `project/feature`. Depending on context such as OKRs, PRD, A/B test, retrospective, include objectives, hypotheses, requirements, metrics, learnings, and next steps.',
        useCase: 'Create',
        roles: [
            'Program Management',
            'Design',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'create-recurring-calendar-meeting',
    // 	title: 'Create recurring calendar meeting',
    // 	prompt:
    // 		'Create a `number of minutes` recurring calendar meeting every `day` at `HH:MM am/pm` `timezone` for `project` with `person`.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-release-notes',
    // 	title: 'Create release notes',
    // 	prompt:
    // 		'Create clear release documentation for `project/product`. Include release date, features, fixes, known issues, and Jira work items/references if found. Provide output in multiple formats such as Confluence, PDF, Markdown as needed.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'Customer Support'],
    // },
    // {
    // 	id: 'create-resolution-notes',
    // 	title: 'Create resolution notes',
    // 	prompt:
    // 		'Create resolution notes for future reference suitable for other agents and team leads to quickly understand the following work item and its resolution: `work item link`. Include a brief and clear description of the problem, the identified root cause, and a summary of the diagnostic steps and actions performed. Clearly state the exact resolution that was implemented. Specify the total time from ticket creation to resolution using HH:MM format, or days/hours if longer.',
    // 	useCase: 'Create',
    // 	roles: ['Helpdesk Support', 'Customer Support', 'IT Ops'],
    // },
    // {
    // 	id: 'draft-blog-post',
    // 	title: 'Draft a blog post',
    // 	prompt:
    // 		'Draft a blog post or marketing collateral for `product/feature`. Highlight key benefits, use cases, and include customer testimonials if available.',
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Product', 'Sales'],
    // },
    // {
    // 	id: 'draft-usability-testing-script',
    // 	title: 'Draft a usability testing script',
    // 	prompt:
    // 		'Draft a detailed usability testing script for the following feature/product `Confluence page link`. The script should be suitable for a moderated session and include the following sections: Introduction for the participant (Reassure the participant that the focus is on the product, not their performance), Warm-up/background questions, Scenario setup, Task instructions, and Wrap-up questions. For each task, specify what a successful outcome looks like and, if appropriate, include a rating scale for ease of use. Throughout, use accessible, concise, and clear language, avoid jargon and directional UI language, keep instructions and questions short and focused, and ensure the script is easy to follow for both moderator and participant, formatting it as a template that can be easily adapted for different products or features',
    // 	useCase: 'Create',
    // 	roles: ['Design', 'Product'],
    // },
    // {
    // 	id: 'draft-and-send-email',
    // 	title: 'Draft and send email',
    // 	prompt:
    // 		"Draft an email to `email address` with the subject `Subject` with a message regarding `topic/purpose`. Once I've confirmed, send this email.",
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'edit-confluence-page-status',
        title: 'Edit Confluence page status',
        prompt: "Update this page's status to Ready for Review: `Confluence page link`",
        useCase: 'Execute',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'explain-acronym',
    // 	title: 'Explain an acronym',
    // 	prompt:
    // 		"Explain the meaning of the acronym '`acronym`' in this context: `context`. Provide its full form and a brief definition.",
    // 	useCase: 'Learn',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'explain-end-to-end-service-flow',
    // 	title: 'Explain End-to-End Service Flow',
    // 	prompt:
    // 		'Explain the `process/system flow` for `feature` as experienced by `end-user/customer`. Include each step from `start event` to `end event`. Highlight any system interactions, notifications, and common issues or exceptions. Provide diagrams or documentation links if available.',
    // 	useCase: 'Learn',
    // 	roles: [
    // 		'Sales',
    // 		'IT Ops',
    // 		'Program Management',
    // 		'Customer Support',
    // 		'Product',
    // 		'Security',
    // 		'Helpdesk Support',
    // 		'Engineering',
    // 	],
    // },
    {
        id: 'explain-code',
        title: 'Explain this code',
        prompt: 'Explain what the code below does, describing its purpose, how it works, and any important details or logic involved. Use clear, concise language suitable for someone with basic programming knowledge. `Insert code snippet`.',
        useCase: 'Learn',
        roles: [
            'Engineering'
        ]
    },
    {
        id: 'extract-key-insights-datasets',
        title: 'Extract key insights from datasets',
        prompt: '`Upload dataset file(s)` Based on the provided dataset, please analyze and present the top 5 most interesting observations, highlights, or trends, identifying segments that were more likely to respond in a certain way, significant patterns, or unexpected insights from the data.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-analyze-customer-contracts',
    // 	title: 'Find and analyze information from customer contracts',
    // 	prompt:
    // 		'Analyze all existing contracts for `project/customer segment/time period` and extract information on response times, maintenance obligations, and product rates. Present findings in a comparative table, highlighting any variations between customers. If available, include contract names (`Contract name/ID`), customer names (`Customer A, Customer B]), and any relevant contract dates (`Effective Date, Expiry Date`).',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management'],
    // },
    {
        id: 'find-prioritize-open-pull-requests',
        title: 'Find and prioritize open pull requests',
        prompt: "Summarize all my open pull requests in across all repositories I have access to in Bitbucket, as well as all pull requests where I'm assigned as a reviewer. Clearly indicate the number of pull requests pending my review and the total number of open PRs involving me. Group the results by repository and include key details such as PR title, status, author, and last updated date.",
        useCase: 'Summarize',
        roles: [
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-hr-policies',
    // 	title: 'Find HR policies',
    // 	prompt:
    // 		'Find all the HR policies that a new hire joining the `location` office would need during onboarding. Reference the latest HR policy resources. Organize results in a table and check if all required policies and contacts are included.',
    // 	useCase: 'Find',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'find-information-3p-sources',
    // 	title: 'Find information from 3P sources',
    // 	prompt: 'Find the latest `topic` presentation in our Google Drive or other 3rd party sources.',
    // 	useCase: 'Find',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    {
        id: 'find-overdue-jira-work-items',
        title: 'Find overdue Jira work items for my team',
        prompt: 'Show all overdue work items for my team, including links to them and how long they have been overdue.',
        useCase: 'Find',
        roles: [
            'Engineering',
            'IT Ops',
            'Helpdesk Support',
            'Program Management'
        ]
    },
    // {
    // 	id: 'find-potential-security-vulnerabilities',
    // 	title: 'Find potential security vulnerabilities',
    // 	prompt:
    // 		'For this pull request `pull request ID`, identify and summarize any changes that were made that have potential security vulnerabilities.',
    // 	useCase: 'Find',
    // 	roles: ['Security', 'IT Ops'],
    // },
    // {
    // 	id: 'find-related-jira-projects',
    // 	title: 'Find related Jira projects',
    // 	prompt: 'What Jira projects have ongoing work that relates to this decision: `description`?',
    // 	useCase: 'Find',
    // 	roles: ['Program Management', 'Product', 'Engineering'],
    // },
    {
        id: 'find-relevant-confluence-pages',
        title: 'Find relevant Confluence pages',
        prompt: 'For `work item ID/project/feature`, find and list any related Confluence pages or reference work items. Include links and a brief summary of how each is relevant.',
        useCase: 'Find',
        roles: [
            'Program Management',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-requirements-jira-work-item',
    // 	title: 'Find requirements for a Jira work item',
    // 	prompt:
    // 		'Identify and document the requirements for work item `work item ID`. Ensure all necessary details are captured, including dependencies and acceptance criteria.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'find-subject-matter-expertise',
    // 	title: 'Find subject-matter expertise',
    // 	prompt:
    // 		'Find the subject matter expert for `topic`. I need to contact them for `purpose, e.g., advice, review, collaboration`. Confirm the recommended person is the most relevant and available expert.',
    // 	useCase: 'Find',
    // 	roles: ['General', 'Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'draft-it-support-response',
    // 	title: 'Draft IT Support response',
    // 	prompt:
    // 		'Draft a reply to a user who is experiencing `topic` issues. Provide clear, empathetic guidance and suggest next steps for resolving the problem using this guide/playbook [Confluence page link]. Here is the user request: `User request`.',
    // 	useCase: 'Create',
    // 	roles: ['Customer Support', 'Helpdesk Support'],
    // },
    {
        id: 'find-latest-company-policies',
        title: 'Find the latest company policies',
        prompt: 'How do I request reimbursements for my travels?',
        useCase: 'Learn',
        roles: [
            'General'
        ]
    },
    {
        id: 'generate-faq',
        title: 'Generate an FAQ',
        prompt: "Map out the typical customer journey for `product/service`, from initial discovery through onboarding, usage, and support. Then, generate top FAQs that customers most frequently ask at each stage\u2014covering how to get started, feature usage, troubleshooting, billing, and best practices\u2014with concise, step-by-step answers formatted for a chatbot.",
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Program Management',
            'Product',
            'Marketing'
        ]
    },
    {
        id: 'generate-post-project-surveys',
        title: 'Generate post-project surveys',
        prompt: "Create a comprehensive evaluation survey for `project` to assess the project's performance, including successes, challenges, areas for improvement, and lessons learned. Include questions such as scale, multiple choice, and open answer covering: objectives and outcomes, budget and resources, team performance and collaboration, challenges and problem-solving, stakeholder satisfaction, and recommendations for future projects.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Product',
            'General'
        ]
    },
    // {
    // 	id: 'identify-upsell-opportunities',
    // 	title: 'Identify upsell opportunities',
    // 	prompt:
    // 		"Analyze the provided call transcript `link to call transcript` with the customer `customer name` and identify all instances where the customer expresses interest in additional features or services. For each instance, include relevant background context, the exact customer quote indicating interest, and a brief explanation of why it represents a potential upsell opportunity. Additionally, recommend the most suitable upsell product or service based on the customer's expressed needs or goals.",
    // 	useCase: 'Analyze',
    // 	roles: ['Sales', 'Product', 'Customer Support', 'Marketing'],
    // },
    {
        id: 'learn-company-procedure-information',
        title: 'Learn about company procedure information',
        prompt: 'Summarize the standard procedures for `process/activity` across the company. Include step-by-step instructions and reference documents.',
        useCase: 'Summarize',
        roles: [
            'General',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'plan-sprint-tasks',
    // 	title: 'Plan sprint tasks',
    // 	prompt:
    // 		'Generate a detailed task list for our upcoming sprint using the information provided in `project poster`. For each task, include the task name, a brief description, the responsible team member, and estimated completion time. Organize the tasks by priority level and group them according to their related user stories to ensure clarity and alignment with sprint goals. Flag any missing details needed to finalize sprint planning.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'IT Ops'],
    // },
    // {
    // 	id: 'prepare-performance-review',
    // 	title: 'Prepare for your performance review',
    // 	prompt:
    // 		'Prepare talking points for an upcoming growth conversation with my manager, summarizing my work between `dates`, organized by key projects. The points should facilitate a productive discussion about my performance, achievements, and areas for improvement. They should be clear, concise, and backed by specific examples and evidence. Organize into sections for each major project, including: project overview, my specific contributions, and relevant links.',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'retrieve-pull-request-insights-jira',
    // 	title: 'Retrieve pull request insights from Jira',
    // 	prompt:
    // 		'For the given Jira work item Jira work item `link to Jira work item`, retrieve all linked pull requests across repositories. Include each pull request number, title, current review status such as Draft, Open, Approved, Merged, or Rejected, the associated reviewers, and the merge date if applicable. Output a structured table with the columns PR Number, Title, Status, Reviewers, and Merge Date.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering'],
    // },
    // {
    // 	id: 'review-improve-presentation',
    // 	title: 'Review and improve presentation',
    // 	prompt:
    // 		'Review this presentation `upload or link presentation slides/script` and provide me with suggestions on how to improve it. Please consider the following context: the audience consists of [audience, e.g., senior executives, students, clients], the primary goal is [goal, e.g., to persuade, to inform, to inspire], and the desired outcome is `outcome, e.g., increased engagement, clear understanding, actionable next steps`. Focus your feedback on the overall structure, flow, clarity, and impact, and tailor your suggestions to maximize effectiveness for this specific audience and goal.',
    // 	useCase: 'Review',
    // 	roles: ['General'],
    // },
    {
        id: 'review-improve-writing',
        title: 'Review and improve writing',
        prompt: 'Rewrite the following message to make it more clear, concise, and professional while retaining all key details: `Insert message here`.',
        useCase: 'Review',
        roles: [
            'General',
            'Sales',
            'Customer Support'
        ]
    },
    {
        id: 'search-policies-questionnaires',
        title: 'Search policies related to questionnaires',
        prompt: 'Search all internal security and compliance policies and provide answers to the following questionnaire. Reference policy documents and highlight relevant sections for each answer.',
        useCase: 'Find',
        roles: [
            'Security',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'send-ms-teams-weekly-progress',
    // 	title: 'Send MS Teams message of weekly progress',
    // 	prompt:
    // 		'Draft a summary of the key updates and additions I made over the past week. Send this summary in MS Teams to `Teams channel link`. Confirm the draft with me before sending.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'send-slack-weekly-progress',
        title: 'Send Slack message of weekly progress',
        prompt: 'Draft a summary of the key updates and additions I made over the past week. Send this summary in Slack to `Teams channel link`. Confirm the draft with me before sending.',
        useCase: 'Execute',
        roles: [
            'General'
        ]
    },
    {
        id: 'suggest-process-streamlining',
        title: 'Suggest process streamlining',
        prompt: 'Suggest ways to streamline the process for `process/task`. Identify steps that can be automated or simplified to reduce manual work and produce more succinct outputs.',
        useCase: 'Learn',
        roles: [
            'Program Management',
            'IT Ops',
            'Engineering'
        ]
    },
    {
        id: 'summarize-track-project-updates',
        title: 'Summarize and track project updates',
        prompt: 'Summarize the status and history of `project/topic/feature`. Include key initiatives, progress made, stakeholders, decisions, timelines, and relevant documents. Highlight upcoming milestones or blockers.',
        useCase: 'Summarize',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'summarize-confluence-page-google-doc',
    // 	title: 'Summarize Confluence page and add to Google doc',
    // 	prompt:
    // 		'Summarize key points and any action items/next steps in this Confluence page: `Confluence page link` and add this summary to a new Google doc titled "`title`" under the folder "`folder`."',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'summarize-engineering-requests',
    // 	title: 'Summarize engineering requests',
    // 	prompt: 'Review and summarize recent Engineering Requests (ERs) for my team.',
    // 	useCase: 'Review',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'summarize-meeting-notes',
        title: 'Summarize meeting notes',
        prompt: 'Summarize the meeting with the transcript `attach file or paste transcript`, including main topics discussed, key decisions, and action items.',
        useCase: 'Summarize',
        roles: [
            'General'
        ]
    },
    {
        id: 'synthesize-user-testing-findings',
        title: 'Synthesize findings from user testing',
        prompt: 'Synthesize key insights from my user testing: `Confluence page link/transcript`. Identify the top pain points or issues that users faced during the testing. Categorize these issues by severity and impact on user experience.',
        useCase: 'Analyze',
        roles: [
            'Design'
        ]
    },
    {
        id: 'visualize-data-charts',
        title: 'Visualize your data into charts',
        prompt: '`Upload your dataset file(s)` Based on the uploaded dataset file, determine the most effective way to visualize the data. Identify the key structure and variables within the dataset and the most likely user goals for this data, to suggest and describe the most appropriate type of visualization.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Engineering',
            'Marketing'
        ]
    }
];
const $08b97b2e27a84eff$export$802094cfe9873dbe = [
    // Google Drive
    {
        id: '3p-google-drive-callout-risks-fy27',
        title: 'Callout the risks in FY27 Strategy doc',
        prompt: 'Callout the risks you see in the FY27 Strategy doc shared with me.',
        useCase: 'Review',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive'
        ]
    },
    {
        id: '3p-google-drive-find-product-specs-last-month',
        title: 'Find product specs in Google Drive from last month',
        prompt: 'Find product specs in Google Drive that are created in the last month',
        useCase: 'Find',
        roles: [
            'Product',
            'Engineering',
            'Program Management'
        ],
        appIds: [
            'google_drive'
        ]
    },
    {
        id: '3p-google-drive-onboarding-guide',
        title: 'Create an onboarding guide from Google Drive folder',
        prompt: 'Create an onboarding guide to new hires using documents in {product} folder.',
        useCase: 'Create',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive'
        ]
    },
    // Salesforce
    {
        id: '3p-salesforce-recommend-next-steps-deals',
        title: 'Recommend next steps for my deals',
        prompt: 'Recommend next steps for my deals',
        useCase: 'Execute',
        roles: [
            'Sales'
        ],
        appIds: [
            'salesforce'
        ]
    },
    // SharePoint & One Drive
    {
        id: '3p-sharepoint-onboarding-guide',
        title: 'Create onboarding guide',
        prompt: 'Create an onboarding guide for new hires using documents in `product` folder',
        useCase: 'Create',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-sharepoint-find-product-specs-last-month',
        title: 'Find product specs from last month',
        prompt: 'Find product specs in `Sharepoint/Onedrive` that were created in the last month',
        useCase: 'Find',
        roles: [
            'Product',
            'Engineering',
            'Program Management'
        ],
        appIds: [
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-sharepoint-callout-risks-fy27',
        title: 'Callout the risks in Strategy doc',
        prompt: 'Callout the risks you see in the FY27 Strategy doc shared with me.',
        useCase: 'Review',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    }
];
const $08b97b2e27a84eff$var$staticPromptsWithSkill = [
    // {
    // 	id: 'summarize-release',
    // 	title: 'Summarize release',
    // 	prompt:
    // 		"'/summarize-release' this `Jira release` for `product` to generate an executive snapshot. Include: 1) key changes grouped by epic or component, 2) risks and blockers with owners and dates, 3) quality signals (open bugs, regressions, flaky tests), 4) planned rollout and key dates, and 5) clear next steps for stakeholders.",
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'create-release',
        title: 'Create release',
        prompt: "'/create-release' in this `Jira space` to create a new release with start and release dates. Include completed work items and summarize what's included by epic or team.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Engineering'
        ],
        tags: [
            'jira-releases'
        ]
    },
    // {
    // 	id: 'draft-release-notes',
    // 	title: 'Draft release notes',
    // 	prompt:
    // 		'\'/draft-release-notes\' for this `Jira release` and related `Confluence page` to generate customer-facing release notes. Organize into "What\'s new", "Improvements", "Fixes", and "Known issues" with clear, non-technical language.',
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'create-work-items',
    // 	title: 'Create work items',
    // 	prompt:
    // 		"'/create-work-items' from this `Confluence page` (feature spec) in this `Jira space`. Break the feature into epics, stories, and tasks with summaries, descriptions, and estimates. List everything created, grouped by epic.",
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'write-status-update',
    // 	title: 'Write status update',
    // 	prompt:
    // 		"'/write-status-update' with this `Jira space` and these `Confluence pages` to draft a status update for `project/initiative` over the last `time period`. Include overall RAG, key achievements, major risks/blockers with owners, and next steps.",
    // 	useCase: 'Create',
    // 	roles: ['Program Management', 'Product'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'page-catchup',
    // 	title: 'Page catchup',
    // 	prompt:
    // 		"'/page-catchup' this `Confluence page` to summarize what changed in the last `time period`. Highlight new sections, major edits, important comments, and open tasks or questions.",
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'update-work-items',
    // 	title: 'Update work items',
    // 	prompt:
    // 		"'/update-work-items' for these `Jira work items` in this `Jira space` to bulk update: set assignee, add label, and move items to a new status if no blockers. Show a summary of planned changes first.",
    // 	useCase: 'Execute',
    // 	roles: ['Program Management', 'Engineering'],
    // },
    // {
    // 	id: 'manage-jira-permissions',
    // 	title: 'Manage Jira permissions',
    // 	prompt:
    // 		"'/manage-jira-permissions' for this `Jira work item` or `Jira space` to diagnose permission issues, explain missing permissions, and provide admin guidance to resolve.",
    // 	useCase: 'Execute',
    // 	roles: ['IT Ops', 'Security'],
    // },
    // {
    // 	id: 'find-jira-settings',
    // 	title: 'Find Jira settings',
    // 	prompt:
    // 		'\'/find-jira-settings\' for this `Jira space` and my goal "`desired behavior`". Tell me which settings to change, where to find them, and any trade-offs.',
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'manage-jira-workflows',
        title: 'Manage Jira workflows',
        prompt: "'/manage-jira-workflows' for this `Jira space` to analyze its workflow: explain statuses, transitions, top workflow rules, and propose simplifications.",
        useCase: 'Execute',
        roles: [
            'IT Ops',
            'Program Management'
        ],
        tags: [
            'jira-workflows'
        ]
    },
    // {
    // 	id: 'search-assets',
    // 	title: 'Search Assets',
    // 	prompt:
    // 		'\'/search-assets\' in this `JSM project` for "`asset search criteria`" and highlight any related to this `JSM incident` or `Jira work item`. Return a table of matching assets.',
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    // {
    // 	id: 'create-pir',
    // 	title: 'Create PIR',
    // 	prompt:
    // 		"'/create-pir' for this `JSM incident` and related `Confluence pages` to draft a complete Post Incident Review with all standard sections.",
    // 	useCase: 'Create',
    // 	roles: ['IT Ops'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'analyze-incident-root-cause',
        title: 'Find root cause of an incident (RCA)',
        prompt: "'/analyze-incident-root-cause' for this `JSM incident` to analyze details, linked alerts, changes, assets, and similar incidents. Propose likely root cause and investigation steps.",
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'find-incident-root-cause',
        title: 'Find incident root cause',
        prompt: "'/find-incident-root-cause' for this `JSM incident` to infer the most likely root cause and provide a stakeholder-friendly summary.",
        useCase: 'Find',
        roles: [
            'IT Ops',
            'General'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'find-incidents',
    // 	title: 'Find incidents',
    // 	prompt:
    // 		'\'/find-incidents\' in this `JSM project` for incidents from the last `time period` matching "`criteria`". Group by status or service, show counts, and surface the most impactful incidents.',
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'find-similar-incidents',
        title: 'Find similar incidents',
        prompt: "'/find-similar-incidents' for this `JSM incident` to find the most similar historical incidents, how they were resolved, and any recurring patterns.",
        useCase: 'Find',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'suggest-problem-ticket',
        title: 'Suggest problem ticket',
        prompt: "'/suggest-problem-ticket' for this `JSM incident` to check for similar incidents and, if recurring, propose a problem ticket with all key details and links.",
        useCase: 'Create',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-fields',
        title: 'Suggest incident fields',
        prompt: "'/suggest-incident-fields' for this `JSM incident` to propose values for service, component, priority, impact, urgency, and major incident flag, with justifications.",
        useCase: 'Execute',
        roles: [
            'Helpdesk Support',
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-sme',
        title: 'Suggest incident SME',
        prompt: "'/suggest-incident-sme' for this `JSM incident` to recommend the best people or teams to involve, with reasons and suggested actions.",
        useCase: 'Find',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'summarize-incident',
        title: 'Summarize incident',
        prompt: "'/summarize-incident' for this `JSM incident` to create an executive summary with impact, timeline, root cause, mitigation, and next steps.",
        useCase: 'Summarize',
        roles: [
            'IT Ops',
            'General'
        ]
    },
    // {
    // 	id: 'find-alerts',
    // 	title: 'Find alerts',
    // 	prompt:
    // 		"'/find-alerts' in this `JSM project` for alerts from the last `time period`. Group by service and severity, highlight recurring alerts, and relate to incidents or changes.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    // {
    // 	id: 'recommend-playbook',
    // 	title: 'Recommend playbook',
    // 	prompt:
    // 		"'/recommend-playbook' for this `alert` or `JSM incident` to suggest the best runbooks or playbooks, with links and first steps.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    {
        id: 'assess-change-risk-insights',
        title: 'Assess change risk insights',
        prompt: "'/show-changes' for this `JSM change request` to assess risk, explain drivers, and suggest safeguards like canary deployments or extra approvals.",
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'get-data-insights',
        title: 'Get data insights',
        prompt: "'/get-data-insights' for this `Jira space` to create charts (throughput, cycle time, WIP) and interpret trends, bottlenecks, and recommendations.",
        useCase: 'Analyze',
        roles: [
            'Engineering',
            'Program Management'
        ],
        enableDeepResearch: true
    }
];
const $08b97b2e27a84eff$export$124449e33e777089 = [
    ...new Set([
        $08b97b2e27a84eff$var$PROMPT_LIBRARY_SKILL_TAG,
        ...$08b97b2e27a84eff$var$staticPromptsWithSkill.flatMap((card)=>card.tags ?? [])
    ])
];
const $08b97b2e27a84eff$export$47aa2ee75b720c2e = ()=>{
    const enableSkillsUiM1 = (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1');
    const promptCards = enableSkillsUiM1 && (0, $dh538.fg)('rovo_skills_prompt_library') ? [
        ...$08b97b2e27a84eff$var$staticPromptsWithSkill,
        ...$08b97b2e27a84eff$var$staticPrompts
    ] : $08b97b2e27a84eff$var$staticPrompts;
    return {
        promptCards: promptCards
    };
};
module.exports["useCaseOptions"] = $08b97b2e27a84eff$export$9fa6e712ef03097f;
module.exports["roleOptions"] = $08b97b2e27a84eff$export$9472c6a87dde5170;
module.exports["promptContainsSkillTagSyntax"] = $08b97b2e27a84eff$export$9957a153ee0b4061;
module.exports["app3pPrompts"] = $08b97b2e27a84eff$export$802094cfe9873dbe;
module.exports["promptCardSkillRegistryTags"] = $08b97b2e27a84eff$export$124449e33e777089;
module.exports["usePromptCards"] = $08b97b2e27a84eff$export$47aa2ee75b720c2e;

});

parcelRegister("boRaI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");


var $b0ri0 = parcelRequire("b0ri0");


var $dAyNE = parcelRequire("dAyNE");


var $1nYBG = parcelRequire("1nYBG");


var $7vkPX = parcelRequire("7vkPX");


var $70S4K = parcelRequire("70S4K");


var $i3kbP = parcelRequire("i3kbP");


var $2ONP7 = parcelRequire("2ONP7");


var $jvJxv = parcelRequire("jvJxv");


var $e9z1z = parcelRequire("e9z1z");

const $90920980e2243e44$var$createIcon = (src)=>()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: src,
            alt: ''
        });
const $90920980e2243e44$var$defaultIcon = $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($i3kbP))));
const $90920980e2243e44$export$cbe04d535daede57 = {
    Analyze: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($b0ri0)))),
    Brainstorm: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($dAyNE)))),
    Review: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($jvJxv)))),
    Summarize: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($e9z1z)))),
    Create: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($1nYBG)))),
    Execute: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($7vkPX)))),
    Find: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($70S4K)))),
    Learn: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($2ONP7))))
};
const $90920980e2243e44$export$8581fc8a588fa6e0 = $90920980e2243e44$var$defaultIcon;
const $90920980e2243e44$export$9b54dda66a3b3d54 = (useCase)=>{
    if (useCase === undefined || !(useCase in $90920980e2243e44$export$cbe04d535daede57)) return $90920980e2243e44$var$defaultIcon;
    return $90920980e2243e44$export$cbe04d535daede57[useCase];
};
module.exports["promptUseCaseIconMap"] = $90920980e2243e44$export$cbe04d535daede57;
module.exports["defaultPromptUseCaseIcon"] = $90920980e2243e44$export$8581fc8a588fa6e0;
module.exports["getUseCaseIcon"] = $90920980e2243e44$export$9b54dda66a3b3d54;

});

parcelRegister("b0ri0", function(module, exports) {
module.exports = new URL("analyze-icon.5c4c7ecb.svg", import.meta.url).toString();

});

parcelRegister("dAyNE", function(module, exports) {
module.exports = new URL("brainstorm-icon.f24d96f2.svg", import.meta.url).toString();

});

parcelRegister("1nYBG", function(module, exports) {
module.exports = new URL("create-icon.59c93a6c.svg", import.meta.url).toString();

});

parcelRegister("7vkPX", function(module, exports) {
module.exports = new URL("execute-icon.d7c359b6.svg", import.meta.url).toString();

});

parcelRegister("70S4K", function(module, exports) {
module.exports = new URL("find-icon.63225fe6.svg", import.meta.url).toString();

});

parcelRegister("i3kbP", function(module, exports) {
module.exports = new URL("general-prompt-icon.5618909f.svg", import.meta.url).toString();

});

parcelRegister("2ONP7", function(module, exports) {
module.exports = new URL("learn-icon.7e0ca0d6.svg", import.meta.url).toString();

});

parcelRegister("jvJxv", function(module, exports) {
module.exports = new URL("review-icon.7da7ded4.svg", import.meta.url).toString();

});

parcelRegister("e9z1z", function(module, exports) {
module.exports = new URL("summarize-icon.5a91c5af.svg", import.meta.url).toString();

});

parcelRegister("hji5f", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ivb8S = parcelRequire("ivb8S");


var $9DBk6 = parcelRequire("9DBk6");

var $d282Z = parcelRequire("d282Z");


var $9wGTI = parcelRequire("9wGTI");


var $6vgLy = parcelRequire("6vgLy");


var $gqypm = parcelRequire("gqypm");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");

const $34ce633e2263efc5$var$ONBOARDING_DELAY_MS = 3000;
const $34ce633e2263efc5$var$MIN_READ_TIME_MINUTES = 3;
const $34ce633e2263efc5$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $34ce633e2263efc5$export$e8b6c5ff97e8b0d2 = ({ contentId: contentId, onShow: onShow, skip: skip, readTime: readTime })=>{
    const [showChangeboarding, setShowChangeboarding] = (0, $42omo.useState)(false);
    const validReadTime = readTime && readTime >= $34ce633e2263efc5$var$MIN_READ_TIME_MINUTES;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: userPersonalizationData, loading: userTargetingLoading } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !isLicensed || !userId
    });
    const attributes = userPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = attributes?.find(({ name: name })=>name === $34ce633e2263efc5$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { shouldExclude: shouldExcludeNewUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: 28
    });
    const shouldSkip = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $9wGTI.fg)('confluence_audio_briefing_changeboarding') || skip || !validReadTime || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    shouldExcludeNewUser || userTargetingLoading;
    // If the content wrapper tour flag is enabled, we need to check if the user has dismissed the content wrapper tour
    // Otherwise, we only need to check if the user has seen the audio briefing
    // This is to avoid showing the audio briefing spotlight to users who have not seen the content wrapper tour
    const onboardingStateKeys = (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? [
        (0, $d282Z.ONBOARDING_INSIGHTS).AUDIO_BRIEFING,
        (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedContentWrapperTour
    ] : [
        (0, $d282Z.ONBOARDING_INSIGHTS).AUDIO_BRIEFING
    ];
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(onboardingStateKeys, shouldSkip);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { hasAudioBriefingChangeboardingBeenSeen: hasAudioBriefingChangeboardingBeenSeen, hasDismissedContentWrapperTour: hasDismissedContentWrapperTour } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const shouldShowChangeboarding = (0, $42omo.useMemo)(()=>{
        const shouldCheckContentWrapperTour = !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') || hasDismissedContentWrapperTour;
        const areConditionsMet = !shouldSkip && !onboardingStateLoading && !onboardingStateError && shouldCheckContentWrapperTour && !hasAudioBriefingChangeboardingBeenSeen;
        return !!areConditionsMet;
    }, [
        onboardingStateLoading,
        onboardingStateError,
        hasDismissedContentWrapperTour,
        hasAudioBriefingChangeboardingBeenSeen,
        shouldSkip
    ]);
    // The effect that auto opens the popper
    (0, $42omo.useEffect)(()=>{
        // Always reset spotlight on content change or if conditions change
        setShowChangeboarding(false);
        if (shouldShowChangeboarding) {
            const timer = setTimeout(()=>{
                setShowChangeboarding(true);
                onShow();
            }, $34ce633e2263efc5$var$ONBOARDING_DELAY_MS);
            return ()=>clearTimeout(timer);
        }
    }, [
        contentId,
        shouldShowChangeboarding,
        onShow
    ]);
    const handleCloseChangeboarding = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $d282Z.ONBOARDING_INSIGHTS).AUDIO_BRIEFING,
            value: 'true'
        });
        setShowChangeboarding(false);
    }, [
        setOnboardingState
    ]);
    return {
        showChangeboarding: showChangeboarding,
        handleCloseChangeboarding: handleCloseChangeboarding
    };
};
module.exports["useAudioBriefingChangeboarding"] = $34ce633e2263efc5$export$e8b6c5ff97e8b0d2;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("hFUQ8", function(module, exports) {

let $cde25b373f5e62d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cde25b373f5e62d8$var$load("gtxmI"),
    $cde25b373f5e62d8$var$load("jrkRK"),
    $cde25b373f5e62d8$var$load("7t5Ax"),
    $cde25b373f5e62d8$var$load("lVBal"),
    $cde25b373f5e62d8$var$load("3ZAtx"),
    $cde25b373f5e62d8$var$load("2Gceu"),
    $cde25b373f5e62d8$var$load("lLK0D"),
    $cde25b373f5e62d8$var$load("7EorR"),
    $cde25b373f5e62d8$var$load("fisfU"),
    $cde25b373f5e62d8$var$load("Wowvf"),
    $cde25b373f5e62d8$var$load("hhss7"),
    $cde25b373f5e62d8$var$load("dek7I"),
    $cde25b373f5e62d8$var$load("dYtBN"),
    $cde25b373f5e62d8$var$load("kNV5Y"),
    $cde25b373f5e62d8$var$load("6wr18"),
    $cde25b373f5e62d8$var$load("kjZZD"),
    $cde25b373f5e62d8$var$load("kE5yv"),
    $cde25b373f5e62d8$var$load("6Tb8o"),
    $cde25b373f5e62d8$var$load("ffEVr"),
    $cde25b373f5e62d8$var$load("aEk9k")
]).then(()=>parcelRequire('e1z3L'));

});

parcelRegister("4ZXww", function(module, exports) {
const $6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $6699361aa30cfc48$export$461ea60ca403d592 = {
    MORE_ACTIONS_ITEMS: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
    OBJECT_SIDEBAR_CONTROL: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
    SIDEBAR_DETAILS_BUTTON: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
module.exports["OBJECT_SIDEBAR_TOUR_TARGETS"] = $6699361aa30cfc48$export$461ea60ca403d592;

});

parcelRegister("k7UhM", function(module, exports) {

let $ea701f4cea092b19$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea701f4cea092b19$var$load("6wr18"),
    $ea701f4cea092b19$var$load("ffEVr"),
    $ea701f4cea092b19$var$load("1jVx9")
]).then(()=>parcelRequire('3D12W'));

});

parcelRegister("9Ima4", function(module, exports) {

let $712969ee490642ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $712969ee490642ea$var$load("k3amn").then(()=>parcelRequire('5A18u'));

});

parcelRegister("7rWz7", function(module, exports) {

let $56c87be7be078a90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56c87be7be078a90$var$load("1dIEH").then(()=>parcelRequire('1hCz7'));

});

parcelRegister("7K4N2", function(module, exports) {

let $5a308b7718b214de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a308b7718b214de$var$load("6wr18"),
    $5a308b7718b214de$var$load("ffEVr"),
    $5a308b7718b214de$var$load("lX2ZR")
]).then(()=>parcelRequire('bl7WT'));

});

parcelRegister("8KEyg", function(module, exports) {

let $65f213537d560539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65f213537d560539$var$load("7inDN"),
    $65f213537d560539$var$load("4wPZ7")
]).then(()=>parcelRequire('eQF4d'));

});

parcelRegister("6HPDw", function(module, exports) {

let $4e1ed0214d2ddd70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e1ed0214d2ddd70$var$load("6wr18"),
    $4e1ed0214d2ddd70$var$load("ffEVr"),
    $4e1ed0214d2ddd70$var$load("3aT4s")
]).then(()=>parcelRequire('ce71E'));

});

parcelRegister("7SQUd", function(module, exports) {

let $5bd69d872506a733$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bd69d872506a733$var$load("1x778"),
    $5bd69d872506a733$var$load("31msE")
]).then(()=>parcelRequire('9POeP'));

});

parcelRegister("7mgQ0", function(module, exports) {

let $55b7a61ff96f40e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55b7a61ff96f40e0$var$load("KSMZE").then(()=>parcelRequire('jFrMf'));

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<e139440afb86fce20d0d7fdd22b96ac3>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<b0fb41d42738db4128917afea956b213>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<6f07c4fac57f6dc212d11302afa5f44f>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("fVTNs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children
        })
    });
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("7tXrp", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("3J7nf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $ivb8S = parcelRequire("ivb8S");


var $gTyTP = parcelRequire("gTyTP");


var $3jwuS = parcelRequire("3jwuS");


var $8Lx5S = parcelRequire("8Lx5S");


var $1zBOs = parcelRequire("1zBOs");


var $bPDOf = parcelRequire("bPDOf");

var $9DBk6 = parcelRequire("9DBk6");


var $evORK = parcelRequire("evORK");


var $cgSxj = parcelRequire("cgSxj");


var $irr7I = parcelRequire("irr7I");

const $575144cb3db51cc4$export$7e64b0f7c7042443 = {
    introSpotlight: {
        isVisible: false,
        complete: ()=>{}
    },
    liveDocTour: {
        isVisible: false,
        complete: ()=>{}
    },
    contentWrapperTour: {
        isVisible: false,
        complete: ()=>{}
    },
    aiButtonTour: {
        isVisible: false,
        complete: ()=>{}
    }
};
const $575144cb3db51cc4$export$a26d1635f48253f6 = (changeboarding)=>Object.values(changeboarding).some((tour)=>{
        if (typeof tour === 'object' && tour !== null && 'isVisible' in tour) return tour.isVisible;
        return false;
    });
const $575144cb3db51cc4$export$bea8fd520e488fdb = ()=>{
    const [introSpotlightDismissed, setIntroSpotlightDismissed] = (0, $42omo.useState)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isAIFCOnbardingEligible: isAIFCOnbardingEligible, loading: isAIFCOnbardingEligibleLoading, error: isAIFCOnbardingEligibleError } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { isEstablishedUser: isEstablishedUser, loading: isEstablishedUserLoading, error: isEstablishedUserError } = (0, $1zBOs.useIsEstablishedUser)({
        skip: !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap')
    });
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS)),
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap'));
    const { hasDismissedIntroSpotlight: hasDismissedIntroSpotlight, hasDismissedLiveDocTour: hasDismissedLiveDocTour, hasSeenAIFCSpotlight: hasSeenAIFCSpotlight, isAIFCSpotlightActive: isAIFCSpotlightActive } = (0, $ivb8S.deserializeState)(data);
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePagesAvailableInSpace = (0, $cgSxj.useIsLivePagesAvailableInSpace)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // AIFC onboarding is showing if the user is eligible and has not seen the spotlight or the spotlight is active
    const isAIFCOnboardingShowing = isAIFCOnbardingEligible && (!hasSeenAIFCSpotlight || isAIFCSpotlightActive);
    const introSpotlightBaseCase = !isAIFCOnboardingShowing && !introSpotlightDismissed && isLivePagesFeatureEnabled && !hasDismissedLiveDocTour && !hasDismissedIntroSpotlight && isLivePagesAvailableInSpace && !isLivePage && (isLicensed || isGuest);
    const showIntroSpotlight = introSpotlightBaseCase && !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && (0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap');
    const showGAIntroSpotlight = introSpotlightBaseCase && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding');
    const showAiButtonTour = false;
    const { isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding, isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding, loading: nav4Loading, error: nav4Error } = (0, $irr7I.useIsNav4Changeboarding)();
    const completeIntroSpotlight = (0, $42omo.useCallback)(()=>{
        setIntroSpotlightDismissed(true);
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedIntroSpotlight,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeAiButtonTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedAiButtonTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    // Skip onboarding for new users if features are enabled, by marking eligible onboarding as complete.
    // If we did not check to see if they were eligible for each onboarding before marking it complete,
    // we would risk marking onboarding complete when the feature is not yet enabled.
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) return;
        if (error || loading || isEstablishedUserError || isEstablishedUserLoading || isAIFCOnbardingEligibleLoading || isAIFCOnbardingEligibleError) return;
        if (!isEstablishedUser) {
            if (showIntroSpotlight) completeIntroSpotlight();
            if (showAiButtonTour) completeAiButtonTour();
        }
    }, [
        isEstablishedUser,
        showIntroSpotlight,
        showAiButtonTour,
        completeAiButtonTour,
        completeIntroSpotlight,
        completeLiveDocTour,
        error,
        isAIFCOnbardingEligibleLoading,
        isAIFCOnbardingEligibleError,
        isEstablishedUserError,
        isEstablishedUserLoading,
        loading
    ]);
    if (error || nav4Error || isAIFCOnbardingEligibleError) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        error: error || nav4Error || isAIFCOnbardingEligibleError
    };
    if (loading || nav4Loading || isEstablishedUserLoading || isAIFCOnbardingEligibleLoading) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        loading: true
    };
    if (showGAIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    // Do not start Live Doc changeboarding until eligible user has completed nav4 changeboarding
    if (isUserEnrolledInNav4Changeboarding && !isUserCompletedNav4Changeboarding) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (!isEstablishedUser) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (showAiButtonTour) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        aiButtonTour: {
            isVisible: true,
            complete: completeAiButtonTour
        }
    };
    if (showIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    return $575144cb3db51cc4$export$7e64b0f7c7042443;
};
module.exports["isLiveDocChangeboardingActive"] = $575144cb3db51cc4$export$a26d1635f48253f6;
module.exports["useLiveDocChangeboarding"] = $575144cb3db51cc4$export$bea8fd520e488fdb;

});

parcelRegister("1zBOs", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $e4b48658f7bfd739$export$fbded7f0a0c86e5e = ({ skip: skip })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    const { data: data, loading: loading, error: error } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: skip || !userId,
        variables: {
            userId: userId ?? ''
        }
    });
    const isEstablishedUser = Boolean(data?.experimentalUserPersonalization?.attributes?.some(({ name: name, value: value })=>name === isEstablishedUserTraitName && value === 'true'));
    return {
        isEstablishedUser: isEstablishedUser,
        loading: loading,
        error: error
    };
};
module.exports["useIsEstablishedUser"] = $e4b48658f7bfd739$export$fbded7f0a0c86e5e;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("30D0J", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
        method: 'GET',
        parseResult: (response)=>({
                experimentalUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables
    });
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("evORK", function(module, exports) {

var $dlSEv = parcelRequire("dlSEv");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $dlSEv.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("cgSxj", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $ep3mz = parcelRequire("ep3mz");


var $iLgzu = parcelRequire("iLgzu");

const $3ddccd966453cb80$export$6dd95cedb3ff0cda = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const { data: enabledContentTypesData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsLivePagesAvailableInSpaceSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`, {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    });
    return enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled : false;
};
module.exports["useIsLivePagesAvailableInSpace"] = $3ddccd966453cb80$export$6dd95cedb3ff0cda;

});

parcelRegister("irr7I", function(module, exports) {

var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gz8ZY = parcelRequire("gz8ZY");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT = 'segment_confluence_nav_4_changeboarding_cloned_siteuser';
const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT = 'completed_cc-nav-4-changeboarding-prod';
const $e18371ec7eace185$var$isExpectedError = (error)=>{
    if ((0, $1uFM6.isUnauthorizedError)(error)) // 401s are expected when users don't have permissions
    return true;
    return false;
};
const $e18371ec7eace185$export$67ed1464307296e4 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { data: data, loading: loading, error: error } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !isNav4Enabled
    });
    if (error && $e18371ec7eace185$var$isExpectedError(error)) // Suppress error from Splunk
    (0, $7Sm4c.markErrorAsHandled)(error);
    if (!isNav4Enabled) return {
        isUserEnrolledInNav4Changeboarding: false,
        isUserCompletedNav4Changeboarding: false
    };
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    const isUserEnrolledInNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT && value === 'true'));
    const isUserCompletedNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT && !!value));
    return {
        isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding,
        isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding,
        loading: loading,
        error: error
    };
};
module.exports["useIsNav4Changeboarding"] = $e18371ec7eace185$export$67ed1464307296e4;

});

parcelRegister("gz8ZY", function(module, exports) {
/**----------------!!!!!!!!!!!!!!!!!!!!!!----------------------------
*   When Changing this file ensure you keep the pure function version
*              getIsNav4Enabled.ts in sync as well!
 -----------------!!!!!!!!!!!!!!!!!!!!!!!--------------------------*/ // eslint-disable-next-line confluence-feature-gating/inline-usage
const $90a9f787a509158d$export$22793b194a2253b9 = ()=>{
    return true;
};
module.exports["useIsNav4Enabled"] = $90a9f787a509158d$export$22793b194a2253b9;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, t4);
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $42omo.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: ''
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: undefined
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("4QOqn"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("4QOqn", function(module, exports) {

let $388321fc7394eeac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $388321fc7394eeac$var$load("7inDN"),
    $388321fc7394eeac$var$load("hhss7"),
    $388321fc7394eeac$var$load("cyGuT"),
    $388321fc7394eeac$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("cJeDc", function(module, exports) {
var $c39b3ef3793f3f0e$export$3f98ccc336fde004 = /*#__PURE__*/ function(FeedbackVariant) {
    FeedbackVariant["AFTER_AIFC_MODAL_CLOSE"] = "after-aifc-modal-close";
    FeedbackVariant["AFTER_UPDATE_STREAM_COMPLETE"] = "after-update-stream-complete";
    return FeedbackVariant;
}({});
module.exports["FeedbackVariant"] = $c39b3ef3793f3f0e$export$3f98ccc336fde004;

});

parcelRegister("5gEqE", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $815712ef274e8115$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false
};
const $815712ef274e8115$var$store = (0, $1P1Tu.createStore)({
    name: 'uiStore',
    initialState: $815712ef274e8115$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$815712ef274e8115$var$initialState
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            }
    }
});
const $815712ef274e8115$var$useStore = (0, $9zUhf.createHook)($815712ef274e8115$var$store);
const $815712ef274e8115$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen }] = $815712ef274e8115$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen
    };
};
const $815712ef274e8115$export$cd2fc25ddd3752d4 = (0, $9zUhf.createActionsHook)($815712ef274e8115$var$store);
module.exports["useUIStore"] = $815712ef274e8115$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $815712ef274e8115$export$cd2fc25ddd3752d4;

});

parcelRegister("i08Mr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $e459ef83dafb04f4$var$initialState = {
    fullScreen: false,
    externalEmbed: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true
    }
};
const $e459ef83dafb04f4$export$ab340e857ee89c62 = $e459ef83dafb04f4$var$initialState;
const $e459ef83dafb04f4$var$uiConfig = /*#__PURE__*/ (0, $42omo.createContext)($e459ef83dafb04f4$var$initialState);
const $e459ef83dafb04f4$export$3063519296e335bf = $e459ef83dafb04f4$var$uiConfig.Provider;
const $e459ef83dafb04f4$export$e83755c3ab7a4493 = ()=>(0, $42omo.useContext)($e459ef83dafb04f4$var$uiConfig);
const $e459ef83dafb04f4$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $dh538.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    return {
        ...{
            ...$e459ef83dafb04f4$var$initialState,
            ...processedConfig,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? $e459ef83dafb04f4$var$initialState.enableBrowserContextBanner,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...$e459ef83dafb04f4$var$initialState.elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        }
    };
};
module.exports["UIConfigProvider"] = $e459ef83dafb04f4$export$3063519296e335bf;
module.exports["useUIConfig"] = $e459ef83dafb04f4$export$e83755c3ab7a4493;
module.exports["createUIConfig"] = $e459ef83dafb04f4$export$3e623b13d2da727a;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("gd8AW", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");

const $e5ba90f4b97bd7c1$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("cAdj8", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $eSUdr.default)`query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId status:["current" "archived" "draft"]){nodes{id type status space{id}operations{operation targetType}version{number}}}}`;
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: ''
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("d3UlG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5NXxU = parcelRequire("5NXxU");


var $iIEgX = parcelRequire("iIEgX");

var $6yCLg = parcelRequire("6yCLg");


var $cPtvM = parcelRequire("cPtvM");


var $kAaxz = parcelRequire("kAaxz");

function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $42omo.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $5NXxU.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $42omo.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}
module.exports["useConvoAIStreaming"] = $d7c3e272b37735b1$export$d6e2ae1e990d7e71;

});

parcelRegister("6yCLg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXpOY = parcelRequire("aXpOY");

function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $42omo.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableEffect"] = $725c584c19c66c44$export$916f6bbdfa1987d0;

});

parcelRegister("dOOm2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7hpmn = parcelRequire("7hpmn");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64c374ed616824e$var$GradientPropertyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f64c374ed616824e$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $7hpmn.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f64c374ed616824e$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f64c374ed616824e$var$baseGlowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f64c374ed616824e$var$defaultBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.large'
});
const $f64c374ed616824e$var$modalBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small'
});
const $f64c374ed616824e$var$innerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f64c374ed616824e$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f64c374ed616824e$var$outerContainerStyles,
        $f64c374ed616824e$var$animationStyles
    ] : [
        $f64c374ed616824e$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f64c374ed616824e$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f64c374ed616824e$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f64c374ed616824e$var$modalBorderRadiusStyles : $f64c374ed616824e$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, $l998X.jsxs)($f64c374ed616824e$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props,
        children: [
            shouldRotate && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles,
                    ...hideGlow ? [] : glowStyles
                ],
                testId: "loading-glow"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles
                ],
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    padding: "space.025",
                    xcss: [
                        $f64c374ed616824e$var$innerContainerStyles,
                        borderRadiusStyles,
                        customInnerContainerStyles
                    ],
                    children: children
                })
            })
        ]
    });
};
module.exports["AIBorder"] = $f64c374ed616824e$export$6ed1e39f4dbe0bbf;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $8C5kA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("40pD8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $42omo.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== isClassificationModalOpen) {
        t1 = {
            isClassificationModalOpen: isClassificationModalOpen
        };
        $[0] = isClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchContextValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
            value: dispatchContextValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contextValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
            value: contextValue
        }, t3);
        $[5] = contextValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $42omo.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
} : ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
} : ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("ayQVU", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!content?.metadata?.frontend?.fabricEditorSupported && // For pages migrated from DC, with editor property not set, it's easy,
        // they'll always be auto-converted. We explicitly set the editor property
        // to v1 when reverting back to TinyMCE.
        (editorProperty === '' || // For pages created in cloud, with editor property set to v1, we only want to show
        // the auto-conversion settings when it is initially converted to fabric editor.
        // This means the editor property is still set to TinyMCE (v1) but the page is Fabric Editor.
        editorProperty === 'v1' && content?.body?.dynamic?.representation === 'atlas_doc_format') : undefined
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? false : undefined
    };
}
module.exports["getAutoConvertionInfo"] = $0e83f72969672585$export$a53517c120ec9f4;

});

parcelRegister("2kB0r", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $dAYOx = parcelRequire("dAYOx");


var $40pD8 = parcelRequire("40pD8");

const $6e3699f987da9ca3$var$messages = (0, $cgtv4.defineMessages)({
    classifyContent: {
        id: "data-classification.ellipsis-classification-menu-item.classify-content",
        defaultMessage: "Classify content"
    }
});
const $6e3699f987da9ca3$export$805becd8a04238d2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { elemBefore: elemBefore } = t0;
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    let t1;
    if ($[0] !== setIsClassificationModalOpen) {
        t1 = ()=>{
            setIsClassificationModalOpen(true);
        };
        $[0] = setIsClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const onClick = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e3699f987da9ca3$var$messages.classifyContent);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== elemBefore || $[4] !== onClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: "classify-content",
            onClick: onClick,
            elemBefore: elemBefore
        }, t2);
        $[3] = elemBefore;
        $[4] = onClick;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ elemBefore: elemBefore })=>{
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const onClick = ()=>{
        setIsClassificationModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: "classify-content",
        onClick: onClick,
        elemBefore: elemBefore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e3699f987da9ca3$var$messages.classifyContent));
};
module.exports["EllipsisClassificationMenuItem"] = $6e3699f987da9ca3$export$805becd8a04238d2;

});

parcelRegister("l3C2L", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ff94b9918380dc5d$export$cc6c027a319af205 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9P0ef",
    name: "ViewChangesDialogLoader",
    loader: async ()=>(await (parcelRequire("4PsmB"))).ViewChangesDialog
});
module.exports["ViewChangesDialogLoader"] = $ff94b9918380dc5d$export$cc6c027a319af205;

});

parcelRegister("4PsmB", function(module, exports) {

let $3841ed4449494d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3841ed4449494d1e$var$load("lJJQ8").then(()=>parcelRequire('iDTLl'));

});

parcelRegister("d8oE8", function(module, exports) {
const $305fd3cd961d4815$export$bd41ea3025fc88df = (push, contentType, spaceKey, contentId, contentStatus)=>{
    if (!contentType || !contentId) return;
    const isBlogPost = contentType === 'blogpost';
    const isCreate = contentStatus === 'draft';
    if (isBlogPost && !isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`);
    else if (!isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`);
    else push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/create?draftId=${contentId}`);
};
module.exports["onClickPageRevert"] = $305fd3cd961d4815$export$bd41ea3025fc88df;

});

parcelRegister("8jTDW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e542faf6fbe5ebc711b672478100d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60eb42a7b08ac844$var$_react = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("42omo")));

var $60eb42a7b08ac844$var$_baseNew = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $60eb42a7b08ac844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudOffline".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for showing when a connection can't be established to the cloud.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60eb42a7b08ac844$var$CloudOfflineIcon = (props)=>/*#__PURE__*/ $60eb42a7b08ac844$var$_react.default.createElement($60eb42a7b08ac844$var$_baseNew.default, Object.assign({
        name: "CloudOfflineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM8.82 12l1.5 1.5H3.75a3.75 3.75 0 0 1-1.42-7.22q.06-.32.14-.62l1.29 1.28a.75.75 0 0 1-.56.63A2.25 2.25 0 0 0 3.75 12zM8 1.5c-.96 0-1.87.24-2.66.65l1.13 1.13a4.25 4.25 0 0 1 5.72 3.23.75.75 0 0 0 .53.59 2.5 2.5 0 0 1 1.36 3.79l1.07 1.07a4 4 0 0 0-1.58-6.15A5.75 5.75 0 0 0 8 1.5"/>`
    }, props));
$60eb42a7b08ac844$var$CloudOfflineIcon.displayName = 'CloudOfflineIcon';
var $60eb42a7b08ac844$var$_default = module.exports.default = $60eb42a7b08ac844$var$CloudOfflineIcon;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("kmWRd", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    let t4;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop) {
        t4 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: "320px",
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t4);
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("4WZFP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("4sbrV", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $hAuc5 = parcelRequire("hAuc5");

const $c4325a25ee151966$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $c4325a25ee151966$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $hAuc5.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $iyDxB.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $c4325a25ee151966$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $c4325a25ee151966$export$dfca419434f7e5a8;

});

parcelRegister("2YmgJ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $a63d9f06b3e123f3$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
		 * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
		 * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
		 */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
		 * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
		 */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            }
    }
});
const $a63d9f06b3e123f3$export$83a8985e8d377ba1 = (0, $9zUhf.createHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$74d7aed167e24a67 = (0, $9zUhf.createActionsHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$d6ed3fb83640b335 = (0, $9zUhf.createStateHook)($a63d9f06b3e123f3$var$store);
module.exports["useConversationActionsStore"] = $a63d9f06b3e123f3$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $a63d9f06b3e123f3$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $a63d9f06b3e123f3$export$d6ed3fb83640b335;

});

parcelRegister("zCcSI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $c96tF = parcelRequire("c96tF");


var $cJeDc = parcelRequire("cJeDc");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $42omo.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    return {
        displaySubmitFlag: true,
        siteId: cloudId,
        product: 'confluence',
        orgId: orgId,
        assistanceServiceConfig: {
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        },
        emojiProvider: emojiProvider,
        userId: userId ?? undefined,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
    };
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $8C5kA.default)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const navigateToObject = (0, $42omo.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $42omo.useCallback)(({ currentConversationId: currentConversationId })=>{
        if (shouldHideFeedback) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: (0, $cJeDc.FeedbackVariant).AFTER_AIFC_MODAL_CLOSE,
            contentType: undefined,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    return {
        customHandlers: {
            handleSubmitSmartCreate: navigateToObject,
            handleCloseSmartCreate: handleCloseSmartCreate
        },
        elements: {
            shouldShowGreeting: shouldShowGreeting ?? undefined
        },
        customGreeting: customGreeting ?? undefined
    };
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("8LJEA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $c33e9757ca53561f$var$BoxStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    backgroundColor: 'elevation.surface.sunken',
    padding: 'space.150',
    borderRadius: 'radius.large',
    borderBottomLeftRadius: 'radius.small'
});
const $c33e9757ca53561f$var$i18n = (0, $cgtv4.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary-loading.title",
        defaultMessage: "Writing a summary"
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $c33e9757ca53561f$export$dd8c26521b6a2fec = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $c33e9757ca53561f$var$BoxStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$c33e9757ca53561f$var$i18n.generatingSummaryText
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($c33e9757ca53561f$var$i18n.generatingSummaryAnimationAlt)
                })
            ]
        })
    });
};
module.exports["AISummaryLoading"] = $c33e9757ca53561f$export$dd8c26521b6a2fec;

});

parcelRegister("8jP1I", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc609ae5f11b40a5$export$409c83e49353f3fb = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0IK46",
    name: "AISummaryFooter",
    loader: async ()=>(await (parcelRequire("bhaeW"))).AISummaryFooter
});
module.exports["AISummaryFooter"] = $fc609ae5f11b40a5$export$409c83e49353f3fb;

});

parcelRegister("bhaeW", function(module, exports) {

let $835939b3e6ea11ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $835939b3e6ea11ce$var$load("kWqME"),
    $835939b3e6ea11ce$var$load("gohij"),
    $835939b3e6ea11ce$var$load("6wr18"),
    $835939b3e6ea11ce$var$load("736as"),
    $835939b3e6ea11ce$var$load("ffEVr"),
    $835939b3e6ea11ce$var$load("hhss7"),
    $835939b3e6ea11ce$var$load("kUbT8")
]).then(()=>parcelRequire('4KbgO'));

});

parcelRegister("bbNJt", function(module, exports) {
/* SummaryPopupScrollableBody.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $d3be62f9dcca5536$export$8fdeb1797011aead = 358;
const $d3be62f9dcca5536$export$3b687fa050c6eb18 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useMaxHeight: useMaxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81d4k _18m91wug _1i4q1hna _o5724jg8 _1suq1j28 _1ke81kwk _155a1mok _aayni8nm _1oglplhp",
            __cmplp.useMaxHeight ? "_c71lgbqg" : "_c71ln7od",
            __cmplp.className
        ])
    });
});
module.exports["MAX_SUMMARY_HEIGHT"] = $d3be62f9dcca5536$export$8fdeb1797011aead;
module.exports["SummaryPopupScrollableBody"] = $d3be62f9dcca5536$export$3b687fa050c6eb18;

});

parcelRegister("dL3KX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $93WqG = parcelRequire("93WqG");


var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");

const $926c216e16fb1b0c$export$64cc6b1b62510d3 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize.";
const $926c216e16fb1b0c$export$1403052b2e306597 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is not enough content to summarize. You can try again later if more is added!";
var $926c216e16fb1b0c$export$6841b1da468d3071 = /*#__PURE__*/ function(HandledErrorType) {
    HandledErrorType["TooMuchContent"] = "tooMuchContent";
    HandledErrorType["NotEnoughContent"] = "notEnoughContent";
    HandledErrorType["RateLimit"] = "rateLimit";
    HandledErrorType["AUPViolation"] = "aupViolation";
    HandledErrorType["GeneralError"] = "generalError";
    return HandledErrorType;
}({});
const $926c216e16fb1b0c$var$ERROR_MAP = {
    [$926c216e16fb1b0c$export$64cc6b1b62510d3]: "tooMuchContent",
    [$926c216e16fb1b0c$export$1403052b2e306597]: "notEnoughContent",
    TOO_MANY_REQUEST: "rateLimit",
    AUP_VIOLATION: "aupViolation"
};
const $926c216e16fb1b0c$var$STREAM_ERROR_MAP = {
    [(0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT]: "notEnoughContent",
    [(0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR]: "notEnoughContent",
    [(0, $93WqG.ConvoAIErrorMessage).RATE_LIMIT]: "rateLimit",
    [(0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS]: "aupViolation"
};
const $926c216e16fb1b0c$var$expectedErrorTypes = [
    "tooMuchContent",
    "notEnoughContent",
    "aupViolation"
];
const $926c216e16fb1b0c$export$628a9b3d5b2b9729 = (experienceName, errorFromApolloOrStream)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { errorType: errorType, isExpectedError: isExpectedError, error: error } = (0, $42omo.useMemo)(()=>{
        if (!errorFromApolloOrStream) return {
            isExpectedError: false,
            stopExperienceTracking: ()=>{},
            errorType: undefined,
            error: new Error('[useSummaryErrorHelper]: error instance is missing')
        };
        let errorMessageFromGQLorStream = '';
        let errorTypeFromGQLorStream = '';
        if ('graphQLErrors' in errorFromApolloOrStream) {
            // The BE only returns one error (the first that it encounters).
            // Therefore, we don't need to loop through the array, and can just rely on index 0
            errorMessageFromGQLorStream = errorFromApolloOrStream.graphQLErrors[0].message;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: errorFromApolloOrStream,
                errorType: errorTypeFromGQLorStream
            };
        } else {
            errorMessageFromGQLorStream = errorFromApolloOrStream.message.message_template;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$STREAM_ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: new Error(errorFromApolloOrStream.message.content),
                errorType: errorTypeFromGQLorStream
            };
        }
    }, [
        errorFromApolloOrStream
    ]);
    const stopExperienceTracking = ()=>{
        if (isExpectedError) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: experienceName,
                reason: `Can not generate summary due to ${errorType}`
            });
        } else experienceTracker.fail({
            name: experienceName,
            error: error
        });
    };
    return {
        isExpectedError: isExpectedError,
        stopExperienceTracking: stopExperienceTracking,
        error: error,
        errorType: errorType
    };
};
module.exports["HandledErrorType"] = $926c216e16fb1b0c$export$6841b1da468d3071;
module.exports["useSummaryErrorHelper"] = $926c216e16fb1b0c$export$628a9b3d5b2b9729;

});

parcelRegister("53ZHq", function(module, exports) {
const $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$b4fefae0b724683f = 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$2876254020381b5e = 'https://www.atlassian.com/legal/acceptable-use-policy';
module.exports["TROUBLE_SHOOTING_DOCS_URL"] = $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1;
module.exports["USAGE_LIMITS_DOCS_URL"] = $ddccf0ae2c3101d9$export$b4fefae0b724683f;
module.exports["ACCEPTABLE_USE_POLICY_URL"] = $ddccf0ae2c3101d9$export$2876254020381b5e;

});

parcelRegister("5ruin", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $1P1Tu.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $9zUhf.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;

});

parcelRegister("i1vUz", function(module, exports) {

var $4qmCZ = parcelRequire("4qmCZ");


var $8SLNj = parcelRequire("8SLNj");


var $8G3G6 = parcelRequire("8G3G6");


var $8uM2K = parcelRequire("8uM2K");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $h2uld = parcelRequire("h2uld");

const $649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery = (0, $8G3G6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $8SLNj.default);
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType, isRefreshRovoButton = false)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery, {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $jMyy4.useQueryInterop)((0, $4qmCZ.default), {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !isRovoButtonEnabled,
        fetchPolicy: 'network-only'
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    // Guard against cases where lastViewedTime would otherwise cause a NaN parse result
    const cleanedLastViewedTime = lastViewedTime.replace(/\[.*?\]$/, '');
    const parsedLastViewedTime = Date.parse(cleanedLastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const isFirstTimeVisit = Number.isNaN(parsedLastViewedTime);
    const lastViewedDate = isFirstTimeVisit ? undefined : new Date(parsedLastViewedTime);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading || readTimeLoading;
    let showCatchupAsDefault = false;
    let showSummarizeAsDefault = true;
    if (!parsedLastViewedTime && !isFirstTimeVisit || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading,
        queryError: queryError
    };
    if (isRovoButtonEnabled && pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && isFirstTimeVisit && readTime && readTime >= 5 && !isCurrentUserARecentCollaborator) {
        if (isRefreshRovoButton) return {
            showCatchupAsDefault: showCatchupAsDefault,
            showSummarizeAsDefault: showSummarizeAsDefault,
            readTime: readTime,
            queryLoading: queryLoading
        };
    }
    showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    showSummarizeAsDefault = false;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        showSummarizeAsDefault: showSummarizeAsDefault,
        queryLoading: queryLoading,
        lastViewedDate: lastViewedDate
    };
};
module.exports["useDynamicSplitButton"] = $649e6d4fa880ffb0$export$ca7c63318c849d7a;

});

parcelRegister("4qmCZ", function(module, exports) {
/**
 * @generated SignedSource<<6462f78220074fa59bcd7a2bc6f29acf>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37
const $3f3bb2f2b7df90db$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
            "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
            "metadata": {},
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
        }
    };
}();
$3f3bb2f2b7df90db$var$node.hash = "cb78a829ad38a06c36dc9615c22411b7";
var $3f3bb2f2b7df90db$export$2e2bcd8739ae039 = $3f3bb2f2b7df90db$var$node;
module.exports["default"] = $3f3bb2f2b7df90db$export$2e2bcd8739ae039;

});

parcelRegister("8SLNj", function(module, exports) {
/**
 * @generated SignedSource<<a9786bc227d6709215149cb341e9351f>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190
const $a7452eae54a23656$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "PaginatedContentHistoryList",
            "kind": "LinkedField",
            "name": "contentHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentHistory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ContributorUsers",
                            "kind": "LinkedField",
                            "name": "collaborators",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "userAccountIds"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
            "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
            "metadata": {},
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
        }
    };
}();
$a7452eae54a23656$var$node.hash = "428e55c833e4f9ecc04af6435214d702";
var $a7452eae54a23656$export$2e2bcd8739ae039 = $a7452eae54a23656$var$node;
module.exports["default"] = $a7452eae54a23656$export$2e2bcd8739ae039;

});

parcelRegister("NomII", function(module, exports) {
/* CustomPopupContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eyWa4 = parcelRequire("eyWa4");


var $bmowW = parcelRequire("bmowW");

const $7ecedb5cea5467d4$var$PopupWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _16qs130s _1pbykb7n _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $7ecedb5cea5467d4$export$2db9b01e44994880 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7ecedb5cea5467d4$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, children));
});
module.exports["CustomPopupContainer"] = $7ecedb5cea5467d4$export$2db9b01e44994880;

});

parcelRegister("bmowW", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $cgtv4.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("brrvF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1ytiN = parcelRequire("1ytiN");


var $42MJM = parcelRequire("42MJM");


var $fykBu = parcelRequire("fykBu");


var $7bACx = parcelRequire("7bACx");

const $a68160926e693700$var$i18n = (0, $cgtv4.defineMessages)({
    headerText: {
        id: "quick-summary.upsell.header.text",
        defaultMessage: "Improve productivity with Rovo"
    },
    headerTextAdmin: {
        id: "quick-summary.upsell.header.text.admin",
        defaultMessage: "Improve team productivity with Rovo"
    },
    learnMoreLinkTextUser: {
        id: "quick-summary.upsell.learn-more.link.text.user",
        defaultMessage: "Learn more about Rovo"
    },
    bodyTextAdmin: {
        id: "quick-summary.upsell.body.text.admin",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Upgrade to Premium"
    },
    bodyTextUser: {
        id: "quick-summary.upsell.body.text.user",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Try Rovo today"
    }
});
const $a68160926e693700$export$37172947b8f9cb48 = 'https://www.atlassian.com/software/rovo/guides/end-user-guide/introduction';
const $a68160926e693700$export$9f5718677d288e24 = 'https://www.atlassian.com/software/rovo/guides/admin-guide/introduction';
const $a68160926e693700$export$f552fbd4bef744fa = ()=>{
    const intl = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const headerText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.headerTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.headerText);
    const bodyText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.bodyTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.bodyTextUser);
    const learnMoreLink = isSiteAdmin ? $a68160926e693700$export$9f5718677d288e24 : $a68160926e693700$export$37172947b8f9cb48;
    const learnMoreText = intl.formatMessage($a68160926e693700$var$i18n.learnMoreLinkTextUser);
    const learnMoreLinkProps = (0, $42omo.useMemo)(()=>({
            href: learnMoreLink,
            message: learnMoreText
        }), [
        learnMoreLink,
        learnMoreText
    ]);
    const imageProps = (0, $42omo.useMemo)(()=>({
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($fykBu))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($7bACx)))
            },
            alt: ''
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42MJM.AIUpsell), {
        title: headerText,
        body: bodyText,
        feature: "quickSummary",
        learnMoreLink: learnMoreLinkProps,
        image: imageProps
    });
};
module.exports["QuickSummaryUpsell"] = $a68160926e693700$export$f552fbd4bef744fa;

});

parcelRegister("fykBu", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerLight.edcc3647.svg", import.meta.url).toString();

});

parcelRegister("7bACx", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerDark.e27429f6.svg", import.meta.url).toString();

});

parcelRegister("aUTn5", function(module, exports) {
/* eslint-disable no-restricted-globals */ 
var $9wGTI = parcelRequire("9wGTI");


var $2zMIV = parcelRequire("2zMIV");


var $kbVzJ = parcelRequire("kbVzJ");

const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
        const div = document.createElement('div');
        div.appendChild(selectionRange.cloneContents());
        return div.innerHTML;
    } else return $('<div>').append(selectionRange.cloneContents()).html();
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
            const parentElement = selectionRange.parentElement();
            const rect = parentElement.getBoundingClientRect();
            clientRects = [
                {
                    top: rect.top,
                    left: rect.left,
                    bottom: rect.top + scrollTop + rect.height,
                    right: rect.left + scrollLeft + rect.width
                }
            ];
        } else {
            const $parentElement = $(selectionRange.parentElement());
            const parentOffset = $parentElement.offset();
            if (parentOffset) clientRects = [
                {
                    top: parentOffset.top - scrollTop,
                    left: parentOffset.left - scrollLeft,
                    bottom: parentOffset.top + ($parentElement.height() || 0),
                    right: parentOffset.left + ($parentElement.width() || 0)
                }
            ];
        }
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
   * Calculates Create Issue dialog target area
   */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
   * Calculates the action panel target area
   */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-of-type"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}
module.exports["IGNORE_SELECTORS"] = $92069b7b1bcb2285$export$c5bc138cfa79c2b2;
module.exports["convertSelectionToLegacyFormat"] = $92069b7b1bcb2285$export$4ba66d628a1e5980;
module.exports["getMatchTraces"] = $92069b7b1bcb2285$export$b297c7070f7a854;

});

parcelRegister("2zMIV", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};
module.exports["isHighlightValidForInlineComment"] = $15cdccae323ae129$export$4042f14350dc38e1;
module.exports["isHighlightValidForBulkCreateJiraIssues"] = $15cdccae323ae129$export$6c73cedfcc8a18f2;
module.exports["getRange"] = $15cdccae323ae129$export$fef151b94550e9f5;
module.exports["textNormalize"] = $15cdccae323ae129$export$42b4db950c80743f;
module.exports["findStickyHeader"] = $15cdccae323ae129$export$6fc0706fcfa876ec;

});

parcelRegister("kbVzJ", function(module, exports) {
// eslint-disable-next-line import/no-cycle

var $2zMIV = parcelRequire("2zMIV");

const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}
module.exports["indexTextNodes"] = $567297790b62d2d4$export$2605a3f2b4d7f885;
module.exports["findMatches"] = $567297790b62d2d4$export$f4585c00f32d9257;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $42omo.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $42omo.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $42omo.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $42omo.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $42omo.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $42omo.useState)(0);
    const providerValue = (0, $42omo.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("b1hSc", function(module, exports) {
/**
 * @generated SignedSource<<75369bf33a7b4e5726120cfbd40e165e>>
 * @relayHash 51e15b77790c5d8cdaef4df99503fbf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386
const $4bf9442691f65266$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "commentState",
                    "value": "UNRESOLVED"
                },
                {
                    "kind": "Variable",
                    "name": "commentType",
                    "variableName": "type"
                }
            ],
            "kind": "ObjectValue",
            "name": "confluenceCommentFilter"
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "singleThreaded",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v6 /*: any*/ ,
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "type"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v21 /*: any*/ ,
                    v20 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v26 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "when"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v34 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v35 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v36 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "51e15b77790c5d8cdaef4df99503fbf3",
            "id": "3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386",
            "metadata": {},
            "name": "ActiveCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$type:[CommentType],$first:Long)@allowHigherTimeout{comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:$type},singleThreaded:true,type:$type,first:$first){__typename,nodes{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}},totalCount}}"
        }
    };
}();
$4bf9442691f65266$var$node.hash = "37d97577cf19b12ed92bf7d36576353c";
var $4bf9442691f65266$export$2e2bcd8739ae039 = $4bf9442691f65266$var$node;
module.exports["default"] = $4bf9442691f65266$export$2e2bcd8739ae039;

});

parcelRegister("9rE3H", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $5b808dc3cc2fdcb5$export$3816ffab97d6707 = 3;
const $5b808dc3cc2fdcb5$export$c2458e66b06ab105 = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag
const $5b808dc3cc2fdcb5$export$ed108990552755bd = 2000;
const $5b808dc3cc2fdcb5$export$37f798be419840d9 = (contentId, isArchived)=>{
    return {
        pageId: contentId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        type: [
            'FOOTER'
        ],
        first: $5b808dc3cc2fdcb5$export$3816ffab97d6707
    };
};
const $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef = ({ pageId: pageId, type: type, isArchived: isArchived = false })=>{
    return {
        pageId: pageId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        first: $5b808dc3cc2fdcb5$export$ed108990552755bd,
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && type && {
            type: [
                type
            ]
        }
    };
};
module.exports["ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG"] = $5b808dc3cc2fdcb5$export$c2458e66b06ab105;
module.exports["buildConsistentActiveCommentsQueryPreloadVariables"] = $5b808dc3cc2fdcb5$export$37f798be419840d9;
module.exports["buildConsistentActiveCommentsQueryVariables"] = $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef;

});


//# sourceMappingURL=ObjectSidebarControl.5c3e1e74.js.map
